// ✅ Cleaned CanvasEngine.js (rotation and resize removed)
import { hexToRgba } from '../libraries/RectangleLibrary';
import InstanceManager from './instanceManager';
import selectionLibrary from '../libraries/SelectionLibrary';
import hierarchyManager from '../libraries/HierarchyManager';
import labelLibrary from '../libraries/LabelLibrary';
import InstanceLibrary from '../libraries/RectangleLibrary';
import layerLibrary from './LayerLibrary';
import layoutEngine from '../libraries/layoutEngine';
import ProjectManager from './ProjectManager';
import RectangleToolHandler from './RectangleToolHandler';
import ToolManager from '../libraries/ToolManager';
import LabelToolHandler from '../tools/LabelToolHandler';
import InstancePlacementHandler from '../tools/InstancePlacementHandler';
import RulerToolHandler from './RulerToolHandler'; // Adjust path accordingly
import FeatureRenderer from './FeatureRenderer'; // Adjust path accordingly
import PolygonToolHandler from '../tools/PolygonToolHandler'; // Adjust path accordingly
import DrcLibrary from './DRCLibrary';
import polygonLibrary from '../libraries/polygonLibrary';
import * as visibilityManager from "./VisibilityManager.js";
import { isLocked } from './VisibilityManager';
import GridSystem from './gridSystem';
// import BooleanLibrary from './BooleanLibrary';
import { handleSearchRequest } from './searchHandler';
import ParametricDotsLibrary from '../libraries/ParametricDotsLibrary';
import { cancelDraftPCellPlacement } from "../perametric/services/parametricPlacementService.js"
import {
  hasPlacedPCell,
  removePlacedPCell,
} from "../perametric/store/placedPCellStore.js";
import { clearActiveDraftPCell } from "../perametric/services/parametricPlacementService.js";
import usePlacementStore from "../store/placementStore";

function getSelectedOnlyVisibilityState() {
  const placementState = usePlacementStore.getState();
  const selectedPCellName =
    placementState.selectedOnlyPCellName ||
    ProjectManager.getSelectedInstanceCell?.() ||
    "";

  return {
    selectedPCellName,
    enabled: Boolean(
      placementState.showOnlySelected &&
      selectedPCellName &&
      hasPlacedPCell(selectedPCellName)
    ),
  };
}

let currentEngineInstance = null;

export function registerCanvasEngine(engineInstance) {
  currentEngineInstance = engineInstance;
  window.removeEventListener("keydown", handleGlobalKeyEvent);
  window.addEventListener("keydown", handleGlobalKeyEvent);
}

function handleGlobalKeyEvent(e) {
  if (currentEngineInstance) {
    currentEngineInstance.handleGlobalKeyDown(e);
  }
}

export default class CanvasEngine {
  constructor(canvas) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.dpr = window.devicePixelRatio || 1;
    this.showGrid = true;
    this.lastEmittedSnap = { x: null, y: null }; // last visited coordinates rishabh
    this.rafSnapId = null; // id of custom event listener for emitter function clearence rishabh
    this.offsetX = 0;
    this.offsetY = 0;
    this.initialScale = 1.0; // Initial zoom level
    this.scale = this.initialScale; // Current zoom level
    this.isPanning = false;
    this.isPanning = false;
    this.startPan = { x: 0, y: 0 };

    this.dragOffset = { x: 0, y: 0 };
    this.dragTarget = null;
    this.gridSpacing = 20;
    this.gridType = 'line';   // Default grid type
    this.labelHandler = new LabelToolHandler(this);
    this.drc = new DrcLibrary(this); // ✅ DRC instance variable
    this.rulerHandler = new RulerToolHandler(this);
    this.FeatureRenderer = new FeatureRenderer(this);
    this.polygonHandler = new PolygonToolHandler(this);
    this.gridSystem = new GridSystem(this);

    this.levelStart = 0;
    this.levelEnd = Infinity;
    this._home = null





    this.minScale = 0.01;  // Minimum zoom out level
    this.maxScale = 500;   // Maximum zoom in level


    this.selectedObjects = [];   // ✅ NEW: Common selected objects
    this.previewRect = null;
    this.previewInstance = null;

    this.gridColor = "#444";

    this.startPan = { x: 0, y: 0 };
    this.setupCanvas();
    this._homeView = { offsetX: this.offsetX, offsetY: this.offsetY, scale: this.scale };
    this.instanceManager = InstanceManager;
    this.previewRect = null;
    this.previewInstance = null;
    this.selectedRects = [];
    this.currentTool = "select";
    this.isDrawing = false;
    window.canvasEngine = this;
    registerCanvasEngine(this);
    this.history = [];
    this.future = [];
    // instance shiv code
    this.isPlacingInstance = false;
    this.instancePlacementHandler = new InstancePlacementHandler(this);
    this.instanceHandler = new InstancePlacementHandler(this);
    // end shiv

    this.useUploadedCells = true; // 🔁 false = manual, true = GDS uploaded
    this.previewInstance = null;
    this.selectionBox = null;
    this.isSelecting = false;
    this.selectionDragStart = null;
    this.leftClickMarquee = false;
    this.doubleClickOnly = false;
    this.lastClickTime = 0;
    // end shiv code


    // ✅ Dot-selection state (parametric placement)
    this.pointerDots = [];
    this.selectedDotA = null;
    this.selectedDotB = null;
    this.dotHitRadiusPx = 10;      // clickable radius in SCREEN px
    this.dotGridSize = 3;          // last chosen grid size (3/4/5)

    this.isDotSelectionMode = false;

    this.drawStart = null;
    this.pasteCooldown = false;
    this.lastPasteTime = 0;
    this.handleGlobalKeyDownBound = this.handleGlobalKeyDown.bind(this);

    this._lastHoverPoint = { x: 0, y: 0 };

    this.dashOffset = 0;
    this.animate = this.animate.bind(this);
    requestAnimationFrame(this.animate);
    this.handleRotateLeft = () => this.rotateSelectedObjects(-90);
    this.handleRotateRight = () => this.rotateSelectedObjects(90);
    // In CanvasEngine constructor, add these after the rotate handlers
    this.handleMirrorX = () => this.mirrorSelectedObjects('x');
    this.handleMirrorY = () => this.mirrorSelectedObjects('y');


    this.rectangleHandler = new RectangleToolHandler(this);
    this.currentTool = ProjectManager.getTool();
    console.log("🎯 CanvasEngine currentTool:", this.currentTool);
    this.bindEvents();
    this.draw();
  }


  // ruler function
  setRulerLineColor(color) {
    this.rulerHandler.setRulerLineColor(color);
    this.draw(); // Redraw to apply new color
  }
  setRulerUnit(value, symbol) {
    this.rulerHandler.setRulerUnit(value, symbol);
    this.draw(); // Redraw to apply new unit
  }

  setRulerValues(count) {
    this.rulerHandler.setRulerValues(count);
    this.draw(); // Redraw to apply new values
  }
  getSnappedToGridCoord(e) {
    const snapToGrid = (value) => {
      const spacing = this.gridSpacing || 10;
      return Math.round(value / spacing) * spacing;
    };
    const worldX = (e.offsetX - this.offsetX) / this.scale;
    const worldY = (e.offsetY - this.offsetY) / this.scale;
    const snapped = {
      x: snapToGrid(worldX),
      y: snapToGrid(worldY),
    };
    return snapped;
  }

  //custom dispatch coordinate event function rishabh
  emitSnappedCoord(snapped) {
    if (
      snapped.x === this.lastEmittedSnap.x &&
      snapped.y === this.lastEmittedSnap.y
    )
      return;

    if (this._rafSnapId) cancelAnimationFrame(this._rafSnapId);
    this.rafSnapId = requestAnimationFrame(() => {
      this.rafSnapId = null;
      this.lastEmittedSnap = { x: snapped.x, y: snapped.y };

      window.dispatchEvent(
        new CustomEvent("snapped-coord", {
          detail: {
            x: snapped.x,
            y: snapped.y,
            // scale: parseFloat(this.scale.toFixed(2)),
          },
        })
      );
    });
  }
  // end ruler function


  setLevelRange(start, end) {
    // sanitize inputs
    this.levelStart = Number.isFinite(start) ? Math.max(0, Math.floor(start)) : 0;
    this.levelEnd = Number.isFinite(end) ? Math.max(this.levelStart, Math.floor(end)) : Infinity;
    this.draw();
  }





  setupCanvas() {
    const rect = this.canvas.getBoundingClientRect();
    this.canvas.width = rect.width * this.dpr;
    this.canvas.height = rect.height * this.dpr;
    this.ctx.scale(this.dpr, this.dpr);
    this.offsetX = this.canvas.width / (2 * this.dpr);
    this.offsetY = this.canvas.height / (2 * this.dpr);
    this.canvas.style.cursor = "default";
  }

  bindEvents() {
    this.canvas.addEventListener("wheel", this.handleZoom.bind(this));

    window.addEventListener('rotate-left', this.handleRotateLeft);
    window.addEventListener('rotate-right', this.handleRotateRight);
    window.addEventListener('mirror-x', this.handleMirrorX);
    window.addEventListener('mirror-y', this.handleMirrorY);
    window.addEventListener("fit-to-screen", this.fitToScreen.bind(this));
    window.addEventListener("go-home", () => this.goHome());

    // this.canvas.addEventListener("click", this.FeatureRenderer.handleCanvasClick.bind(this));
    this.canvas.addEventListener("contextmenu", e => e.preventDefault());
    // inside CanvasEngine constructor
    window.addEventListener("search-objects", this.handleSearchRequest.bind(this));
    // This should already be in your bindEvents() method in CanvasEngine.js
    window.addEventListener("boolean-operation", (e) => {
      const { layer1, layer2, operation, targetLayer } = e.detail;
      this.applyBooleanOperation(layer1, layer2, operation, targetLayer);

      // ✅ UI "Connect" button -> canvas action

    });
    window.addEventListener("connect-dots", () => {
      ParametricDotsLibrary.connectSelectedDots(this);
    });

    this.canvas.addEventListener("dblclick", this.handleDoubleClick.bind(this));
    this.canvas.addEventListener("mousedown", this.handleMouseDown.bind(this));
    this.canvas.addEventListener("mousemove", this.handleMouseMove.bind(this));
    this.canvas.addEventListener("mouseup", this.handleMouseUp.bind(this));
    window.addEventListener("tool-changed", this.handleToolChange.bind(this)); // Custom tool change event is fine

  }


  // ✅ Home: restore the view captured at tool-open time
  goHome() {
    if (!this._homeView) return;
    this.offsetX = this._homeView.offsetX;
    this.offsetY = this._homeView.offsetY;
    this.scale = this._homeView.scale;
    this.draw();
  }

  // ✅ Fit current selected cell into viewport (safe margin so it never clips)
  fitToScreen(padding = 60) {
    const cellName = ProjectManager.getSelectedCell?.() || ProjectManager.getSelectedCell;
    const cell =
      layoutEngine.getCellByName(cellName) ||
      layoutEngine.getUploadedCell(cellName) ||
      layoutEngine.getUploadedCell?.(cellName);
    if (!cell) return;

    // ✅ Use GLOBAL bbox (handles nested instances + rotation + mirror_x already)
    const g = this.getGlobalBoundingBox(cell, { x: 0, y: 0, scale: 1, rotation: 0, mirror_x: false });
    if (!g) return;

    const bboxW = Math.max(1, g.maxX - g.minX);
    const bboxH = Math.max(1, g.maxY - g.minY);
    const cx = g.minX + bboxW / 2;
    const cy = g.minY + bboxH / 2;

    // IMPORTANT: use CSS pixels (rect) because offsetX/offsetY are in CSS px
    const rect = this.canvas.getBoundingClientRect();
    const viewW = rect.width;
    const viewH = rect.height;

    const availW = Math.max(1, viewW - padding * 2);
    const availH = Math.max(1, viewH - padding * 2);

    // ✅ Safe margin so edges never clip due to rounding/DPR
    const SAFE = 0.95;
    let nextScale = Math.min(availW / bboxW, availH / bboxH) * SAFE;
    nextScale = Math.max(0.00000001, Math.min(100, nextScale));

    this.scale = nextScale;
    this.offsetX = viewW / 2 - cx * this.scale;
    this.offsetY = viewH / 2 - cy * this.scale;

    this.draw();
  }


  handleDoubleClick(e) {
    if (ToolManager.getCurrentTool() === "polygon") {
      this.polygonHandler.handleDoubleClick(e);
    }
    if (ToolManager.getCurrentTool() === "ruler") {
      this.rulerHandler.handleMouseRulerDBclick(e);
    }
    if (ToolManager.getCurrentTool() === "path") {
      this.pathHandler.handleDoubleClick(e);
    }

  }


  handleCopy() {
    if (this.selectedRects.length > 0) {
      this.copiedRects = this.selectedRects.map(rect => ({
        ...JSON.parse(JSON.stringify(rect))
      }));
      console.log("📋 Copied via icon:", this.copiedRects);
    }
  }

  setUseUploadedCells(flag) {
    this.useUploadedCells = flag;
  }




  handlePaste() {
    if (!this.lastClickForPaste || !this.copiedRects?.length) return;
    const base = this.copiedRects[0];
    const offsetX = this.lastClickForPaste.x - base.x;
    const offsetY = this.lastClickForPaste.y - base.y;

    const pastedRects = this.copiedRects.map(rect => {
      const newRect = {
        ...JSON.parse(JSON.stringify(rect)),
        x: this.rectangleHandler.snapToGrid(rect.x + offsetX),
        y: this.rectangleHandler.snapToGrid(rect.y + offsetY),
        id: Date.now() + Math.random(),
        selected: false
      };
      InstanceLibrary.addRectangle(newRect.layerId, newRect.x, newRect.y, newRect.width, newRect.height, newRect);
      return newRect;
    });

    this.selectedRects = [...pastedRects];
    this.draw();
    console.log("📥 Pasted at last click:", this.lastClickForPaste);
  }


  handleZoom(e) {
    e.preventDefault();
    const zoomFactor = 1.1;
    const rect = this.canvas.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;
    const worldX = (mouseX - this.offsetX) / this.scale;
    const worldY = (mouseY - this.offsetY) / this.scale;
    const zoomIn = e.deltaY < 0;
    const scaleChange = zoomIn ? zoomFactor : 1 / zoomFactor;
    const newScale = Math.max(0.00000001, Math.min(100, this.scale * scaleChange));
    // const newScale = Math.min(0.0001, this.scale * scaleChange);
    this.offsetX = mouseX - worldX * newScale;
    this.offsetY = mouseY - worldY * newScale;
    this.scale = newScale;
    this.draw();
  }

  smoothZoomToViolation(violation, duration = 500) {
    if (!violation?.location?.length) return;

    const xs = violation.location.map(p => p[0]);
    const ys = violation.location.map(p => p[1]);
    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);

    const violationWidth = maxX - minX || 1;
    const violationHeight = maxY - minY || 1;

    const canvasWidth = this.canvas.width / this.dpr;
    const canvasHeight = this.canvas.height / this.dpr;

    const padding = 20;
    const scaleX = (canvasWidth - padding * 2) / violationWidth;
    const scaleY = (canvasHeight - padding * 2) / violationHeight;
    const targetScale = Math.min(this.maxScale, Math.max(this.minScale, Math.min(scaleX, scaleY)));

    const centerX = (minX + maxX) / 2;
    const centerY = (minY + maxY) / 2;

    const targetX = canvasWidth / 2 - centerX * targetScale;
    const targetY = canvasHeight / 2 + centerY * targetScale; // 👈 FIX: Y inverted

    const startScale = this.scale;
    const startX = this.offsetX;
    const startY = this.offsetY;

    const startTime = performance.now();

    const animate = (time) => {
      const progress = Math.min((time - startTime) / duration, 1);
      const t = 1 - Math.pow(1 - progress, 3); // easeOutCubic

      this.scale = startScale + (targetScale - startScale) * t;
      this.offsetX = startX + (targetX - startX) * t;
      this.offsetY = startY + (targetY - startY) * t;

      this.draw();

      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }

  handleMouseDown(e) {
    // 🖱️ Right-click = start panning
    if (e.button === 2) {
      this.isPanning = true;
      this.startPan = { x: e.clientX - this.offsetX, y: e.clientY - this.offsetY };
      this.canvas.style.cursor = "grabbing";
      e.preventDefault(); // prevent context menu
      return;
    }


    this.lastClickForPaste = {
      x: (e.offsetX - this.offsetX) / this.scale,
      y: (e.offsetY - this.offsetY) / this.scale

    };

    const activeTool = window.ToolManager.getCurrentTool(); // ✅ Get clean tool name
    // ✅ If dots visible, allow dot selection on left click (no object selection)
    if (
      e.button === 0 &&
      this.pointerDots?.length &&
      this.currentTool === "dot-select" &&
      this.isDotSelectionMode
    ) {
      const consumed = ParametricDotsLibrary.handleDotClick(this, e);
      if (consumed) return;
    }
    if (activeTool === "rectangle") {
      console.log("🖐️ Rectangle tool mouseDown");
      this.recordState();
      this.isDrawing = true;
      this.isDragging = false;
      this.rectangleHandler.handleMouseDown(e);
      return;
    }

    if (this.currentTool === "label") {

      this.isDragging = false;
      this.labelHandler.handleMouseDown(e);
      return;
    }

    if (activeTool === "instance") {
      this.instanceHandler.finalizePlacement();
      this.recordState();
      return;
    }
    // ruler code
    if (activeTool === "ruler") {
      this.rulerHandler.handleRulerMouseDown(e);
      return;
    }
    // end ruler
    if (activeTool === "bug&imp") {
      this.FeatureRenderer.handleCommunicationMouseDown(e);
    }

    // if (activeTool === "polygon") {
    //   this.polygonHandler.handleMouseDown(e);
    //   return;
    // }
    if (activeTool === "polygon") {
      if (e.detail && e.detail > 1) return;
      this.polygonHandler.handleMouseDown(e);
      return;
    }


    if (activeTool === "select") {
      console.log("🖐️ Select tool mouseDown");
      this.isDrawing = false;

      // First check if resizing is starting
      if (this.startResize(e)) {
        return; // Skip selection logic if resizing
      }

      // Otherwise proceed to handle selection and dragging
      this.handleSelectObject(e);
      this.startDrag(e);
      if (this.currentTool === 'select') {
        this.startMarquee(e); // shiv code
      }
    }

  }


  handleMouseMove(e) {
    if (this.isPanning) {
      this.offsetX = e.clientX - this.startPan.x;
      this.offsetY = e.clientY - this.startPan.y;
      this.draw();
      return; // skip other handlers
    }
    // ruler purpose
    const snappedCoordinates = this.getSnappedToGridCoord(e); // to get a coordinates rishabh
    this.emitSnappedCoord(snappedCoordinates); // passing coordinates to emitter
    // end ruler purpose
    this.updateMarquee(e); // shiv code
    const pointerX = (e.offsetX - this.offsetX) / this.scale;
    const pointerY = (e.offsetY - this.offsetY) / this.scale;
    this.lastPointer = { x: pointerX, y: pointerY };

    if (this.isMultiMoveMode) {
      this.updateMultiMoveFollow(e);
      return;
    }

    // ruler code
    if (ToolManager.getCurrentTool() === "ruler") {
      this.rulerHandler.handleRulerMouseMove(e);
      this.draw();
    }
    // end ruler code
    if (this.currentTool === "bug&imp") {
      this.FeatureRenderer.handleCommunicationMouseMove(e);
      return;
    }
    if (ToolManager.getCurrentTool() === "polygon") {
      const canvasX = (e.offsetX - this.offsetX) / this.scale;
      const canvasY = (e.offsetY - this.offsetY) / this.scale;
      this.polygonHandler.updateMousePosition(canvasX, canvasY);
      this.draw();
    }


    if (this.currentTool === "rectangle" && this.isDrawing) {
      this.rectangleHandler.handleMouseMove(e);
    } else if (this.currentTool === "instance") {
      this.instancePlacementHandler.updatePreview(e);// ✅ Instance placement handler
    } else if (this.currentTool === "select") {
      if (this.isResizing) {
        this.performResize(e);
      } else {
        this.checkResizeCursor(e);
        this.performDrag(e);
      }
    }

  }

  handleMouseUp(e) {
    if (this.isPanning) {
      this.isPanning = false;
      this.canvas.style.cursor = "default";
      return;
    }
    const activeTool = ToolManager.getCurrentTool();
    this.finishMarquee(e); // shiv code

    if (this.isMultiMoveMode) {
      this.startMultiMoveFromClick(e);
      return;
    }
    if (this.rectangleHandler.moveMode) {
      this.rectangleHandler.exitMultiMoveMode();
      return;
    }

    if (this.currentTool === "rectangle" && this.isDrawing) {
      this.rectangleHandler.handleMouseUp();
      this.isDrawing = false;      // ✅ Immediately stop drawing after mouseUp
      this.drawStart = null;        // ✅ Clear drawStart
      return;
    }

    if (this.activeTool === "instance") {
      this.instanceHandler.finalizePlacement(e); // ✅ Instance placement handler
      return;
    }

    if (activeTool === "polygon") return;

    if (this.currentTool === "bug&imp") {
      this.FeatureRenderer.handleCommunicationMouseUp(e);
      return;
    }

    if (this.currentTool === "bug&imp") {
      this.FeatureRenderer.customStopDrag(e);
      return;
    }

    if (this.currentTool === "select") {
      this.isPanning = false;
      this.stopDrag();
      this.endResize();
    }
  }


  handleToolChange(toolName) {
    this.currentTool = toolName;
    this.isDotSelectionMode = toolName === "dot-select";
    // ✅ Full selection clear
    this.selectedRects = [];
    this.selectedObjects = [];
    selectionLibrary.clearSelection();
    if (toolName !== "polygon") {
      this.polygonHandler?.cancel();
    } else {
      // even when entering polygon, ensure clean start
      this.polygonHandler?.cancel();
    }
    this.draw(); // Refresh canvas without outlines
  }


  animate() {
    this.dashOffset += 1;
    if (this.dashOffset > 1000) this.dashOffset = 0;
    this.draw();
    requestAnimationFrame(this.animate);
  }

  handleGlobalKeyDown(e) {
    if (document.activeElement.tagName === 'INPUT') return;
    if (this.currentTool === "label") {
      this.labelHandler.handleKeyPress(e);
      this.recordState();
    }
    if (e.key === "Escape") {
      this.polygonHandler?.cancel();
      this.exitMultiMoveMode();
      this.isDotSelectionMode = false;
      cancelDraftPCellPlacement();
      this.currentTool = "select";                    // ✅ CanvasEngine ka internal tool
      ToolManager.setTool("select");                // ✅ ProjectManager ka global tool
      window.dispatchEvent(new CustomEvent("tool-changed", { detail: "select" })); // ✅ UI bhi sync
      this.isDrawing = false;
      this.isDragging = false;
      this.drawStart = null;
      this.selectedRects = [];
      this.selectedLabels = [];
      this.draw();
    }
    if (e.key.toLowerCase() === "m") {
      this.enterMultiMoveMode();
    }
    if (e.key === 'Delete') {
      window.canvasEngine.deleteSelectedObjects();
      e.preventDefault();
    }

    if (e.shiftKey && e.key.toLowerCase() === "j") {
      e.preventDefault();

      this.isDotSelectionMode = true;
      this.currentTool = "dot-select";

      ToolManager.setTool("dot-select");

      return;
    }
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'c') {
      window.canvasEngine.copySelectedObjects();
      e.preventDefault();
    }

    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'v') {
      window.canvasEngine.pasteCopiedObjects();
      e.preventDefault();
    }

    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'z') {
      this.undo();
      e.preventDefault();
    }
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'y') {
      this.redo();
      e.preventDefault();
    }
  }




  drawGrid() { this.gridSystem.drawDisplayGrid(); }



  setGridSpacing(spacing) {
    this.gridSpacing = spacing;
    this.draw();
  }
  drawLabels() {
    const ctx = this.ctx;
    ctx.save();
    ctx.translate(this.offsetX, this.offsetY);
    ctx.scale(this.scale, this.scale);
    const labels = labelLibrary.getAll();
    for (let label of labels) {
      if (!labelLibrary.isVisible(label)) continue;
      ctx.fillStyle = 'yellow';
      ctx.font = '12px monospace';
      ctx.fillText(label.text, label.x, label.y);
    }
    ctx.restore();
  }


  resetToolStates() {
    this.isDrawing = false;
    this.isDragging = false;
    this.previewInstance = null;

    if (this.rectangleHandler?.cancelDrawing) {
      this.rectangleHandler.cancelDrawing();
    }
    if (this.labelHandler?.cancelLabeling) {
      this.labelHandler.cancelLabeling();
    }
  }


  //============================================================================================================================================
  // 📋 Common Reusable Operation Functions

  isElementLayerVisible(el) {
    const layerNumber =
      el.layerNumber ?? el.layer ?? el.layerId?.layerNumber;

    const datatypeNumber =
      el.datatypeNumber ?? el.datatype ?? el.layerId?.datatypeNumber;

    // If element has no layer info, don't block it
    if (layerNumber == null || datatypeNumber == null) return true;

    return layerLibrary.isLayerVisible(layerNumber, datatypeNumber);
  }




  snapToGrid(value, axis = 'x') {
    return this.gridSystem.snapScalar(value, axis);
  }
  // ... (Baaki saara code waise hi rahega)




  setDrawingGrid(opts) { this.gridSystem.setDrawingStep(opts); this.draw(); }
  setDrawingOrigin(x, y) { this.gridSystem.setOrigin({ x, y }); }
  toggleSnap(on) { this.gridSystem.setEnabled(on); }


  handleSearchRequest(e) {
    return handleSearchRequest(e, this);
  }

  // mirrorSelectedObjects(axis) {
  //   if (!this.selectedObjects?.length) return;

  //   const seen = new Set();

  //   for (let obj of this.selectedObjects) {
  //     if (!obj || !obj.ref) continue;

  //     const key = `${obj.type}:${obj.ref.id ?? obj.id ?? (obj.ref._uid || obj.ref)}`;
  //     if (seen.has(key)) continue;
  //     seen.add(key);

  //     if (obj.type === 'rectangle' && !obj.ref.locked) {
  //       const rect = obj.ref;
  //       if (axis === 'x') {
  //         rect.mirror_x = !rect.mirror_x;
  //         rect.x = rect.x + rect.width;
  //         rect.width = -rect.width;
  //       } else if (axis === 'y') {
  //         // Y-mirror = X-mirror + 180° rotation
  //         rect.mirror_x = !rect.mirror_x;

  //         // Also apply 180° rotation
  //         const cx = rect.x + rect.width / 2;
  //         const cy = rect.y + rect.height / 2;

  //         // Flip dimensions (same as 180° rotation for rectangles)
  //         rect.x = cx - rect.width / 2;
  //         rect.y = cy - rect.height / 2;
  //       }
  //     }

  //     else if (obj.type === 'label' && !obj.ref.locked) {
  //       const label = obj.ref;
  //       if (axis === 'x') {
  //         label.mirror_x = !label.mirror_x;
  //         if (label.justification) {
  //           switch (label.justification) {
  //             case 'upperleft': label.justification = 'upperright'; break;
  //             case 'upperright': label.justification = 'upperleft'; break;
  //             case 'lowerleft': label.justification = 'lowerright'; break;
  //             case 'lowerright': label.justification = 'lowerleft'; break;
  //             case 'centerleft': label.justification = 'centerright'; break;
  //             case 'centerright': label.justification = 'centerleft'; break;
  //           }
  //         }
  //       } else if (axis === 'y') {
  //         // Y-mirror = X-mirror + 180° rotation
  //         label.mirror_x = !label.mirror_x;

  //         // Apply 180° rotation to justification
  //         if (label.justification) {
  //           switch (label.justification) {
  //             case 'upperleft': label.justification = 'lowerright'; break;
  //             case 'upperright': label.justification = 'lowerleft'; break;
  //             case 'lowerleft': label.justification = 'upperright'; break;
  //             case 'lowerright': label.justification = 'upperleft'; break;
  //             case 'centerleft': label.justification = 'centerright'; break;
  //             case 'centerright': label.justification = 'centerleft'; break;
  //           }
  //         }
  //       }
  //     }

  //     else if (obj.type === 'polygon' && !obj.ref.locked) {
  //       const poly = obj.ref;
  //       const pts = Array.isArray(poly.points) ? poly.points : [];
  //       if (pts.length >= 3) {
  //         let cx = 0, cy = 0;
  //         for (const p of pts) { 
  //           const x = Array.isArray(p) ? p[0] : p.x; 
  //           const y = Array.isArray(p) ? p[1] : p.y; 
  //           cx += x; cy += y; 
  //         }
  //         cx /= pts.length; cy /= pts.length;

  //         poly.points = pts.map(p => {
  //           const x = Array.isArray(p) ? p[0] : p.x;
  //           const y = Array.isArray(p) ? p[1] : p.y;
  //           if (axis === 'x') {
  //             return Array.isArray(p) ? [2 * cx - x, y] : { x: 2 * cx - x, y };
  //           } else {
  //             // Y-mirror = X-mirror + 180° rotation = point reflection through center
  //             return Array.isArray(p) ? [2 * cx - x, 2 * cy - y] : { x: 2 * cx - x, y: 2 * cy - y };
  //           }
  //         });

  //         // Always use mirror_x property
  //         if (axis === 'x' || axis === 'y') {
  //           poly.mirror_x = !poly.mirror_x;
  //         }
  //       }
  //     }

  //     else if (obj.type === 'instance' && !obj.ref.locked) {
  //       const inst = obj.ref;
  //       if (axis === 'x') {
  //         inst.mirror_x = !inst.mirror_x;
  //       } else if (axis === 'y') {
  //         // Y-mirror = X-mirror + 180° rotation
  //         inst.mirror_x = !inst.mirror_x;
  //         // Add 180° rotation
  //         let newRotation = (inst.rotation || 0) + 180;
  //         newRotation = ((newRotation % 360) + 360) % 360;
  //         inst.rotation = newRotation;
  //       }

  //       const cellName = ProjectManager.getSelectedCell();
  //       const uploadedCell = layoutEngine.getUploadedCell(cellName);
  //       if (uploadedCell?.instances) {
  //         const match = uploadedCell.instances.find(i => i.id === inst.id);
  //         if (match) {
  //           match.mirror_x = inst.mirror_x;
  //           if (axis === 'y') {
  //             match.rotation = inst.rotation;
  //           }
  //         }
  //       }
  //       const currentCell = layoutEngine.getCellByName(cellName);
  //       if (currentCell?.instances) {
  //         const match2 = currentCell.instances.find(i => i.id === inst.id);
  //         if (match2) {
  //           match2.mirror_x = inst.mirror_x;
  //           if (axis === 'y') {
  //             match2.rotation = inst.rotation;
  //           }
  //         }
  //       }
  //     }
  //   }

  //   this.draw();
  //   this.recordState();
  //   console.log(`🪞 Mirrored selected objects along ${axis.toUpperCase()} axis`);
  // }


  mirrorSelectedObjects(axis) {
    if (!this.selectedObjects?.length) return;
    this.recordState();
    const seen = new Set();

    for (let obj of this.selectedObjects) {
      if (!obj || !obj.ref) continue;

      const key = `${obj.type}:${obj.ref.id ?? obj.id ?? (obj.ref._uid || obj.ref)}`;
      if (seen.has(key)) continue;
      seen.add(key);

      if (obj.type === 'rectangle' && !obj.ref.locked) {
        const rect = obj.ref;
        if (axis === 'x') {
          rect.mirror_x = !rect.mirror_x;
          rect.x = rect.x + rect.width;
          rect.width = -rect.width;
        } else if (axis === 'y') {
          // For Y-mirroring: flip vertically around center
          rect.mirror_y = !rect.mirror_y;
          const centerY = rect.y + rect.height / 2;
          rect.y = 2 * centerY - (rect.y + rect.height);
          rect.height = -rect.height;
        }
      }

      else if (obj.type === 'label' && !obj.ref.locked) {
        const label = obj.ref;
        if (axis === 'x') {
          label.mirror_x = !label.mirror_x;
          if (label.justification) {
            switch (label.justification) {
              case 'upperleft': label.justification = 'upperright'; break;
              case 'upperright': label.justification = 'upperleft'; break;
              case 'lowerleft': label.justification = 'lowerright'; break;
              case 'lowerright': label.justification = 'lowerleft'; break;
              case 'centerleft': label.justification = 'centerright'; break;
              case 'centerright': label.justification = 'centerleft'; break;
            }
          }
        } else if (axis === 'y') {
          // For Y-mirroring: flip vertically
          if (label.justification) {
            switch (label.justification) {
              case 'upperleft': label.justification = 'lowerleft'; break;
              case 'upperright': label.justification = 'lowerright'; break;
              case 'lowerleft': label.justification = 'upperleft'; break;
              case 'lowerright': label.justification = 'upperright'; break;
              case 'uppercenter': label.justification = 'lowercenter'; break;
              case 'lowercenter': label.justification = 'uppercenter'; break;
            }
          }
        }
      }

      else if (obj.type === 'polygon' && !obj.ref.locked) {
        const poly = obj.ref;
        const pts = Array.isArray(poly.points) ? poly.points : [];
        if (pts.length >= 3) {
          let cx = 0, cy = 0;
          for (const p of pts) {
            const x = Array.isArray(p) ? p[0] : p.x;
            const y = Array.isArray(p) ? p[1] : p.y;
            cx += x; cy += y;
          }
          cx /= pts.length; cy /= pts.length;

          poly.points = pts.map(p => {
            const x = Array.isArray(p) ? p[0] : p.x;
            const y = Array.isArray(p) ? p[1] : p.y;
            if (axis === 'x') {
              return Array.isArray(p) ? [2 * cx - x, y] : { x: 2 * cx - x, y };
            } else {
              // Y-mirror: flip vertically around center
              return Array.isArray(p) ? [x, 2 * cy - y] : { x, y: 2 * cy - y };
            }
          });
        }
      }

      else if (obj.type === 'instance' && !obj.ref.locked &&
        !isLocked(obj.ref.ref)) {
        const inst = obj.ref;
        if (axis === 'x') {
          inst.mirror_x = !inst.mirror_x;
        } else if (axis === 'y') {
          // For Y-mirroring: use mirror_y property (you'll need to add this)
          inst.mirror_y = !inst.mirror_y;
        }

        const cellName = ProjectManager.getSelectedCell();
        const uploadedCell = layoutEngine.getUploadedCell(cellName);
        if (uploadedCell?.instances) {
          const match = uploadedCell.instances.find(i => i.id === inst.id);
          if (match) {
            if (axis === 'x') match.mirror_x = inst.mirror_x;
            if (axis === 'y') match.mirror_y = inst.mirror_y;
          }
        }
        const currentCell = layoutEngine.getCellByName(cellName);
        if (currentCell?.instances) {
          const match2 = currentCell.instances.find(i => i.id === inst.id);
          if (match2) {
            if (axis === 'x') match2.mirror_x = inst.mirror_x;
            if (axis === 'y') match2.mirror_y = inst.mirror_y;
          }
        }
      }
    }

    this.draw();
    console.log(`🪞 Mirrored selected objects along ${axis.toUpperCase()} axis`);
  }


  expandConnectedPCellSelection() {
    if (!this.selectedObjects?.length) return;

    const cellName = ProjectManager.getSelectedCell();
    if (!cellName) return;

    const instanceObjects = this.selectedObjects.filter(
      (obj) => obj.type === "instance" && obj.id
    );

    if (!instanceObjects.length) return;

    const connectedIds = new Set();

    for (const obj of instanceObjects) {
      const groupIds =
        ParametricDotsLibrary.getConnectedInstanceIds?.(cellName, obj.id) || [];

      groupIds.forEach((id) => connectedIds.add(id));
    }

    if (!connectedIds.size) return;

    const createdCell = layoutEngine.getCellByName(cellName);
    const uploadedCell = layoutEngine.getUploadedCell(cellName);

    const nextSelected = [...this.selectedObjects];
    const selectedKeys = new Set(
      nextSelected.map((obj) => `${obj.type}:${obj.id}`)
    );

    const addInstanceIfNeeded = (inst, isUploaded) => {
      if (!inst?.id || !connectedIds.has(inst.id)) return;

      const key = `instance:${inst.id}`;
      if (selectedKeys.has(key)) return;

      nextSelected.push({
        id: inst.id,
        type: "instance",
        ref: inst,
        isUploaded,
      });

      selectedKeys.add(key);
    };

    for (const inst of createdCell?.instances || []) {
      addInstanceIfNeeded(inst, false);
    }

    for (const inst of uploadedCell?.instances || []) {
      addInstanceIfNeeded(inst, true);
    }

    this.selectedObjects = nextSelected;
    selectionLibrary.setSelection(this.selectedObjects);
  }


  handleSelectObject(e) {
    if (this.isMultiMoveMode) return;

    const x = (e.offsetX - this.offsetX) / this.scale;
    const y = (e.offsetY - this.offsetY) / this.scale;

    const ctrlKey = e.ctrlKey || e.metaKey;

    const cellName = ProjectManager.getSelectedCell();
    const cellData = InstanceLibrary.getAllInstances()[cellName] || {};
    const allRects = Object.values(cellData).flat();
    const allLabels = labelLibrary.getAllLabels(cellName);

    let clickedObject = null;

    // 🔷 1. Try to select a label first (UI priority)
    for (let i = allLabels.length - 1; i >= 0; i--) {
      const label = allLabels[i];
      if (label.visible === false) continue;
      // if (el.visible === false) continue;   // ✅ REQUIRED


      this.ctx.font = `${label.fontSize}px monospace`;
      const width = Math.max(this.ctx.measureText(label.text).width, 20);
      const height = label.fontSize;

      let boxX = label.x;
      let boxY = label.y;

      switch (label.justification) {
        case 'upperleft': break;
        case 'upperright': boxX -= width; break;
        case 'lowerleft': boxY -= height; break;
        case 'lowerright': boxX -= width; boxY -= height; break;
        case 'center': boxX -= width / 2; boxY -= height / 2; break;
        case 'centerleft': boxY -= height / 2; break;
        case 'centerright': boxX -= width; boxY -= height / 2; break;
      }

      const left = boxX - 4;
      const top = boxY - 2;
      const right = boxX + width + 4;
      const bottom = boxY + height + 6;

      if (x >= left && x <= right && y >= top && y <= bottom && !label.locked) {
        clickedObject = { id: label.id, type: 'label', ref: label };
        break;
      }
    }

    // 🔷 2. Try to select a rectangle (if no label was clicked)
    // 🔷 2. Smallest-shape-first (rect + polygon)
    // if (!clickedObject) {
    //   const candidates = [];
    //   const cellName = ProjectManager.getSelectedCell();

    //   // --- Created rectangles ---
    //   const createdRects = Object.values(InstanceLibrary.getAllInstances()[cellName] || {}).flat();
    //   for (let i = 0; i < createdRects.length; i++) {
    //     const rect = createdRects[i];
    //     if (rect.visible === false) continue;

    //     const left = Math.min(rect.x, rect.x + rect.width);
    //     const right = Math.max(rect.x, rect.x + rect.width);
    //     const top = Math.min(rect.y, rect.y + rect.height);
    //     const bottom = Math.max(rect.y, rect.y + rect.height);

    //     if (x >= left && x <= right && y >= top && y <= bottom) {
    //       const area = Math.abs(rect.width) * Math.abs(rect.height);
    //       candidates.push({
    //         area,
    //         obj: { id: rect.id, type: 'rectangle', ref: rect, isUploaded: false }
    //       });
    //     }
    //   }

    //   // --- Uploaded rectangles ---
    //   const uploadedCell = layoutEngine.getUploadedCell(cellName);
    //   if (uploadedCell?.elements) {
    //     for (let i = 0; i < uploadedCell.elements.length; i++) {
    //       const el = uploadedCell.elements[i];
    //       if (el.type !== 'rectangle') continue;

    //       const x1 = el.x ?? el.x1 ?? 0;
    //       const y1 = el.y ?? el.y1 ?? 0;
    //       const x2 = el.x2 ?? (x1 + (el.width ?? 0));
    //       const y2 = el.y2 ?? (y1 + (el.height ?? 0));

    //       const left = Math.min(x1, x2);
    //       const right = Math.max(x1, x2);
    //       const top = Math.min(y1, y2);
    //       const bottom = Math.max(y1, y2);

    //       if (x >= left && x <= right && y >= top && y <= bottom) {
    //         const area = Math.abs(x2 - x1) * Math.abs(y2 - y1);
    //         candidates.push({
    //           area,
    //           obj: { id: el.id || crypto.randomUUID(), type: 'rectangle', ref: el, isUploaded: true }
    //         });
    //       }
    //     }
    //   }

    //   // --- Polygons (top-level) ---
    //   const polys = polygonLibrary.getAllPolygons(cellName) || [];
    //   for (let i = 0; i < polys.length; i++) {
    //     const poly = polys[i];
    //     if (poly.visible === false) continue;
    //     if (!Array.isArray(poly.points) || poly.points.length < 3) continue;

    //     if (polygonLibrary.pointInPolygon({ x, y }, poly.points)) {
    //       // Shoelace area (absolute)
    //       let dblArea = 0;
    //       for (let j = 0; j < poly.points.length; j++) {
    //         const [xi, yi] = poly.points[j];
    //         const [xj, yj] = poly.points[(j + 1) % poly.points.length];
    //         dblArea += (xi * yj - xj * yi);
    //       }
    //       const area = Math.abs(dblArea) / 2;
    //       candidates.push({
    //         area: area > 0 ? area : 1, // fallback guard
    //         obj: { id: poly.id, type: 'polygon', ref: poly }
    //       });
    //     }
    //   }

    //   if (candidates.length) {
    //     candidates.sort((a, b) => a.area - b.area);   // ✅ smallest first
    //     clickedObject = candidates[0].obj;
    //   }
    // }
    if (!clickedObject) {
      const candidates = [];
      const createdRects = Object.values(InstanceLibrary.getAllInstances()[cellName] || {}).flat();

      // --- CREATED rectangles (reverse rotate hit)
      for (let i = 0; i < createdRects.length; i++) {
        const rect = createdRects[i];
        if (rect.visible === false) continue;

        const cx = rect.x + rect.width / 2;
        const cy = rect.y + rect.height / 2;

        const angle = -(rect.rotation || 0) * Math.PI / 180;
        const dx = x - cx;
        const dy = y - cy;

        const localX = dx * Math.cos(angle) - dy * Math.sin(angle) + rect.width / 2;
        const localY = dx * Math.sin(angle) + dy * Math.cos(angle) + rect.height / 2;

        if (localX >= 0 && localX <= rect.width && localY >= 0 && localY <= rect.height) {
          const area = Math.abs(rect.width) * Math.abs(rect.height);
          candidates.push({
            area,
            obj: { id: rect.id, type: "rectangle", ref: rect, isUploaded: false }
          });
        }
      }

      // --- UPLOADED rectangles (reverse rotate hit)
      // const uploadedCell = layoutEngine.getUploadedCell(cellName);
      // if (uploadedCell?.elements) {
      //   for (let i = 0; i < uploadedCell.elements.length; i++) {
      //     const el = uploadedCell.elements[i];
      //     if (el.type !== "rectangle") continue;

      //     const w = el.x2 ? el.x2 - el.x1 : el.width;
      //     const h = el.y2 ? el.y2 - el.y1 : el.height;
      //     const x1 = el.x ?? el.x1 ?? 0;
      //     const y1 = el.y ?? el.y1 ?? 0;

      //     const cx = x1 + w / 2;
      //     const cy = y1 + h / 2;

      //     const angle = -(el.rotation || 0) * Math.PI / 180;
      //     const dx = x - cx;
      //     const dy = y - cy;

      //     const localX = dx * Math.cos(angle) - dy * Math.sin(angle) + w / 2;
      //     const localY = dx * Math.sin(angle) + dy * Math.cos(angle) + h / 2;

      //     if (localX >= 0 && localX <= w && localY >= 0 && localY <= h) {
      //       const area = Math.abs(w) * Math.abs(h);
      //       candidates.push({
      //         area,
      //         obj: { id: el.id || crypto.randomUUID(), type: "rectangle", ref: el, isUploaded: true }
      //       });
      //     }
      //   }
      // }
      // --- UPLOADED rectangles (FIXED)
      const uploadedCell = layoutEngine.getUploadedCell(cellName);
      if (uploadedCell?.elements) {
        for (let i = 0; i < uploadedCell.elements.length; i++) {
          const el = uploadedCell.elements[i];
          if (el.type !== "rectangle") continue;
          if (!this.isElementLayerVisible(el)) continue;



          const x1 = el.x ?? el.x1 ?? 0;
          const y1 = el.y ?? el.y1 ?? 0;
          const x2 = el.x2 ?? (x1 + (el.width ?? 0));
          const y2 = el.y2 ?? (y1 + (el.height ?? 0));

          const left = Math.min(x1, x2);
          const right = Math.max(x1, x2);
          const top = Math.min(y1, y2);
          const bottom = Math.max(y1, y2);

          let hit = false;

          // 🔹 Case 1: no rotation → world-space hit (uploaded GDS default)
          if (!el.rotation || el.rotation === 0) {
            hit = (x >= left && x <= right && y >= top && y <= bottom);
          }
          // 🔹 Case 2: rotated rectangle → reverse-rotation hit
          else {
            const w = right - left;
            const h = bottom - top;

            const cx = left + w / 2;
            const cy = top + h / 2;

            const angle = -el.rotation * Math.PI / 180;
            const dx = x - cx;
            const dy = y - cy;

            const localX = dx * Math.cos(angle) - dy * Math.sin(angle) + w / 2;
            const localY = dx * Math.sin(angle) + dy * Math.cos(angle) + h / 2;

            hit = (localX >= 0 && localX <= w && localY >= 0 && localY <= h);
          }

          if (hit) {
            const area = Math.abs((right - left) * (bottom - top));

            candidates.push({
              area,
              obj: {
                id: el.id ?? `uploaded-rect-${i}`,   // ✅ stable ID
                type: "rectangle",
                ref: el,
                isUploaded: true
              }
            });
          }
        }
      }


      if (candidates.length) {
        candidates.sort((a, b) => a.area - b.area);
        clickedObject = candidates[0].obj;
      }
    }


    if (!clickedObject) {
      const createdCell = layoutEngine.getCellByName(cellName);
      const uploadedCell = layoutEngine.getUploadedCell(cellName);

      const allInstances = [
        ...(createdCell?.instances || []).map(inst => ({ ...inst, isUploaded: false })),
        ...(uploadedCell?.instances || []).map(inst => ({ ...inst, isUploaded: true })),
      ];

      for (let i = allInstances.length - 1; i >= 0; i--) {
        const inst = allInstances[i];
        const refCell = inst.isUploaded
          ? layoutEngine.getUploadedCell(inst.ref)
          : layoutEngine.getCellByName(inst.ref);
        if (!refCell) continue;

        // 🔹 Pivot same as rendering
        const { offsetX, offsetY } = this.getChildBoundingBoxCenterOffset(refCell);
        const pivotX = (inst.x || 0) + offsetX;
        const pivotY = (inst.y || 0) + offsetY;

        // 🔹 Transform world → local (inverse of render)
        const theta = ((inst.rotation || 0) * Math.PI) / 180;
        const cos = Math.cos(-theta);
        const sin = Math.sin(-theta);
        const s = inst.scale ?? 1;

        // Step 1. Translate into instance space
        let tx = x - pivotX;
        let ty = y - pivotY;

        // Step 2. Undo rotation
        let rx = cos * tx - sin * ty;
        let ry = sin * tx + cos * ty;

        // Step 3. Undo scaling
        rx /= s;
        ry /= s;

        // Step 4. Undo mirroring (mirror is *applied forward* at render time, so invert it here)
        // const mirrorType = inst.mirror || (inst.mirror_x ? "X" : "NONE");
        let mirrorType = "NONE";
        if (inst.mirror_x && inst.mirror_y) mirrorType = "XY";
        else if (inst.mirror_x) mirrorType = "X";
        else if (inst.mirror_y) mirrorType = "Y";

        if (mirrorType === "X") {
          ry = -ry;
        } else if (mirrorType === "Y") {
          rx = -rx;
        } else if (mirrorType === "XY") {
          rx = -rx;
          ry = -ry;
        }

        // 🔹 Now rx, ry are in the same local space as refCell.elements
        let hit = false;

        for (const el of refCell.elements || []) {
          if (el.type === "rectangle") {
            const ax = el.x ?? el.x1 ?? 0;
            const ay = el.y ?? el.y1 ?? 0;
            const bx = el.x2 ?? (ax + (el.width ?? 0));
            const by = el.y2 ?? (ay + (el.height ?? 0));
            const minX = Math.min(ax, bx);
            const maxX = Math.max(ax, bx);
            const minY = Math.min(ay, by);
            const maxY = Math.max(ay, by);

            if (rx >= minX && rx <= maxX && ry >= minY && ry <= maxY) {
              hit = true;
              break;
            }
          }
          else if (el.type === "polygon" && Array.isArray(el.points)) {
            if (!this.isElementLayerVisible(el)) continue;

            if (polygonLibrary.pointInPolygon({ x: rx, y: ry }, el.points)) {
              hit = true;
              break;
            }
          }
          else if (el.type === "label") {
            if (!this.isElementLayerVisible(el)) continue;
            const size = el.fontSize ?? 12;
            this.ctx.font = `${size}px monospace`;
            const w = Math.max(this.ctx.measureText(el.text || "").width, 20);
            const h = size;
            const bx = el.x ?? 0;
            const by = el.y ?? 0;
            if (rx >= bx && rx <= bx + w && ry >= by && ry <= by + h) {
              hit = true;
              break;
            }
          }
        }

        if (hit) {
          clickedObject = {
            id: inst.id,
            type: "instance",
            ref: inst,
            isUploaded: inst.isUploaded
          };
          break;
        }
      }
    }



    if (!clickedObject) {
      const allPolygons = polygonLibrary.getAllPolygons(cellName) || [];

      for (let i = allPolygons.length - 1; i >= 0; i--) {
        const poly = allPolygons[i];
        if (poly.visible === false) continue;
        //  if (poly.isUploaded && !this.isElementLayerVisible(poly)) continue;
        if (!this.isElementLayerVisible(poly)) continue;

        if (polygonLibrary.pointInPolygon({ x, y }, poly.points)) {
          clickedObject = {
            id: poly.id,
            type: 'polygon',
            ref: poly
          };
          break;
        }
      }
    }


    // 🔷 4. Final selection logic
    if (clickedObject) {
      const alreadySelected = this.selectedObjects.find(
        obj => obj.type === clickedObject.type && obj.id === clickedObject.id
      );

      if (ctrlKey) {
        if (alreadySelected) {
          this.selectedObjects = this.selectedObjects.filter(
            obj => !(obj.type === clickedObject.type && obj.id === clickedObject.id)
          );
        } else {
          this.selectedObjects.push(clickedObject);
        }
      } else {
        this.selectedObjects = [clickedObject];
      }

      selectionLibrary.setSelection(this.selectedObjects);
    } else if (!ctrlKey) {
      this.selectedObjects = [];
      selectionLibrary.clearSelection();
    }

    if (clickedObject?.type === "instance") {
      this.expandConnectedPCellSelection();
    }

    const selectedPCellName =
      clickedObject?.type === "instance" && hasPlacedPCell(clickedObject.ref.ref)
        ? clickedObject.ref.ref
        : "";

    if (selectedPCellName) {
      ProjectManager.setSelectedInstanceCell?.(selectedPCellName);

      window.dispatchEvent(
        new CustomEvent("pcell-instance-selected", {
          detail: {
            cellName: selectedPCellName,
            instanceId: clickedObject.ref.id,
            parentCellName: ProjectManager.getSelectedCell?.(),
          },
        })
      );
    } else {
      ProjectManager.setSelectedInstanceCell?.("");

      window.dispatchEvent(
        new CustomEvent("pcell-instance-selected", {
          detail: {
            cellName: "",
            instanceId: "",
            parentCellName: ProjectManager.getSelectedCell?.(),
          },
        })
      );
    }


    this.draw();
  }




  copySelectedObjects() {
    // this.copiedObjects = this.selectedObjects.map(obj => {
    //   if (obj.type === 'polygon') {
    //     console.log("🧾 Copying polygon points:", obj.ref.points);
    //   }
    // });
    if (!this.selectedObjects?.length) return;

    this.copiedObjects = this.selectedObjects.map(obj => ({
      id: obj.id,
      type: obj.type,
      isUploaded: obj.isUploaded === true,   // ✅ preserve origin
      ref: JSON.parse(JSON.stringify(obj.ref)) // Deep copy to avoid live link
    }));

    console.log("📋 Copied selected objects");
  }

  pasteCopiedObjects() {
    this.recordState();
    if (!this.copiedObjects?.length || !this.lastClickForPaste) return;

    // const base = this.copiedObjects[0];
    // const offsetX = this.lastClickForPaste.x - base.ref.x;
    // const offsetY = this.lastClickForPaste.y - base.ref.y;

    const newObjects = [];
    const cellName = ProjectManager.getSelectedCell();// shiv 
    const baseObj = this.copiedObjects[0];

    let baseX = 0;
    let baseY = 0;

    if (baseObj.type === 'polygon') {
      baseX = baseObj.ref.points?.[0]?.[0] ?? 0;
      baseY = baseObj.ref.points?.[0]?.[1] ?? 0;
    } else {
      baseX = baseObj.ref.x ?? 0;
      baseY = baseObj.ref.y ?? 0;
    }

    const pasteOffsetX = this.lastClickForPaste.x - baseX;
    const pasteOffsetY = this.lastClickForPaste.y - baseY;


    for (let obj of this.copiedObjects) {
      // if (obj.type === 'rectangle') {
      //   const newId = Date.now() + Math.random();

      //   const x = this.snapToGrid(obj.ref.x + offsetX);
      //   const y = this.snapToGrid(obj.ref.y + offsetY);

      //   const newRect = {
      //     ...obj.ref,
      //     id: newId,
      //     x,
      //     y,
      //     selected: false
      //   };

      //   InstanceLibrary.addRectangle(
      //     cellName,
      //     newRect.layerId,
      //     x,
      //     y,
      //     newRect.width,
      //     newRect.height,
      //     newRect
      //   );

      //   // ✅ Get actual live reference from the library
      //   const rectsInLayer = InstanceLibrary.getAllInstances()[newRect.layerId] || [];
      //   const liveRef = rectsInLayer.find(r => r.id === newId);

      //   if (liveRef) {
      //     newObjects.push({ id: newId, type: 'rectangle', ref: liveRef });
      //   }

      // }
      if (obj.type === 'rectangle') {

        // 🔴 CASE A — UPLOADED (GDS) RECTANGLE
        if (obj.isUploaded) {
          const uploadedCell = layoutEngine.getUploadedCell(cellName);
          const layer = layerLibrary.getLayerById(obj.ref.layerId);

          const newRect = {
            ...obj.ref,
            id: crypto.randomUUID(),
            x: this.snapToGrid(obj.ref.x + pasteOffsetX),
            y: this.snapToGrid(obj.ref.y + pasteOffsetY),
            visible: true,
            stroke: layer?.color || obj.ref.stroke,
            fill: layer?.color
              ? layer.color.replace("rgb", "rgba").replace(")", ",0.3)")
              : obj.ref.fill,
          };

          uploadedCell.elements.push(newRect);

          newObjects.push({
            id: newRect.id,
            type: 'rectangle',
            ref: newRect,
            isUploaded: true
          });

        } else {
          // 🟢 CASE B — CREATED RECTANGLE
          const newId = Date.now() + Math.random();

          const x = this.snapToGrid(obj.ref.x + pasteOffsetX);
          const y = this.snapToGrid(obj.ref.y + pasteOffsetY);

          const newRect = {
            ...obj.ref,
            id: newId,
            x,
            y,
            selected: false
          };

          InstanceLibrary.addRectangle(
            cellName,
            newRect.layerId,
            x,
            y,
            newRect.width,
            newRect.height,
            newRect
          );

          const rectsInLayer =
            InstanceLibrary.getAllInstances()[newRect.layerId] || [];

          const liveRef = rectsInLayer.find(r => r.id === newId);

          if (liveRef) {
            newObjects.push({
              id: newId,
              type: 'rectangle',
              ref: liveRef,
              isUploaded: false
            });
          }
        }
      }

      else if (obj.type === 'label') {
        //     const offsetX = this.lastClickForPaste.x - obj.ref.x;
        // const offsetY = this.lastClickForPaste.y - obj.ref.y;
        const x = this.snapToGrid(obj.ref.x + pasteOffsetX);
        const y = this.snapToGrid(obj.ref.y + pasteOffsetY);
        const newLabel = labelLibrary.addLabel(
          cellName,
          obj.ref.layerId,
          x,
          y,
          obj.ref.text,
          obj.ref.color
        );
        newObjects.push({ id: newLabel.id, type: 'label', ref: newLabel });
      }
      //shivcode
      else if (obj.type === 'instance') {

        const cellName = ProjectManager.getSelectedCell();
        const uploadedCell = layoutEngine.getUploadedCell(cellName);
        const createdCell = layoutEngine.getCellByName(cellName);



        if (!uploadedCell) {
          console.warn("❌ No uploaded cell found, aborting instance paste");
          return;
        }

        // 🔑 Create new instance (clone)
        const newInst = {
          ...obj.ref,
          id: crypto.randomUUID(),

          // position
          x: this.snapToGrid(obj.ref.x + pasteOffsetX),
          y: this.snapToGrid(obj.ref.y + pasteOffsetY),

          // SAFETY NORMALIZATION
          level: Number.isFinite(obj.ref.level) ? obj.ref.level : 0,
          rotation: obj.ref.rotation || 0,
          scale: obj.ref.scale || 1,

          // mirror flags
          mirror_x: !!obj.ref.mirror_x,
          mirror_y: !!obj.ref.mirror_y,
        };


        // ✅ DIRECTLY add to uploaded cell
        uploadedCell.instances = uploadedCell.instances || [];
        uploadedCell.instances.push(newInst);



        // ✅ selection must point to SAME object reference
        newObjects.push({
          id: newInst.id,
          type: 'instance',
          ref: newInst,
          isUploaded: true
        });
      }

      // else if (obj.type === 'polygon') {
      //   const newId = Date.now() + Math.random();

      //   const objBasePoint = obj.ref.points?.[0] || [0, 0];
      //   const basePoint = this.copiedObjects[0].ref.points?.[0] || [0, 0];
      //   const dx = objBasePoint[0] - basePoint[0];
      //   const dy = objBasePoint[1] - basePoint[1];

      //   const targetFirstX = this.lastClickForPaste.x + dx;
      //   const targetFirstY = this.lastClickForPaste.y + dy;

      //   const offsetX = targetFirstX - objBasePoint[0];
      //   const offsetY = targetFirstY - objBasePoint[1];

      //   const rawPoints = obj.ref.points || [];

      //   const newPoints = rawPoints
      //     .filter(pt => Array.isArray(pt) && pt.length === 2 && Number.isFinite(pt[0]) && Number.isFinite(pt[1]))
      //     .map(([px, py]) => [
      //       this.snapToGrid(px + offsetX),
      //       this.snapToGrid(py + offsetY)
      //     ]);

      //   console.log("✅ Final new polygon points:", newPoints);

      //   const layer = layerLibrary.getLayerById(obj.ref.layerId) || {
      //     id: "unknown",
      //     name: "NW",
      //     layerNumber: "1",
      //     datatypeNumber: "0",
      //     datatypeName: "drawing",
      //     color: "#F96109",
      //   };

      //   const newPolygon = {
      //     ...obj.ref,
      //     id: newId,
      //     points: newPoints,
      //     selected: false,
      //     layerId: layer.id,
      //     layerName: layer.name,
      //     layerNumber: layer.layerNumber,
      //     datatypeNumber: layer.datatypeNumber,
      //     datatypeName: layer.datatypeName,
      //     stroke: layer.color,
      //     fill: layer.color.replace("rgb", "rgba").replace(")", ",0.3)"),
      //   };

      //   polygonLibrary.addPolygon(cellName, newPolygon);

      //   const updatedCell = layoutEngine.getCellByName(cellName);
      //   const liveRef = updatedCell?.elements?.find(e => e.id === newId);

      //   if (liveRef) {
      //     newObjects.push({ id: newId, type: 'polygon', ref: liveRef });
      //   }
      // }
      else if (obj.type === 'polygon') {
        const cellName = ProjectManager.getSelectedCell();
        if (!cellName) return;

        // 🔑 ALWAYS ensure writable cell
        polygonLibrary.ensureCreatedCell(cellName);

        // const basePoly = this.copiedObjects.find(o => o.type === 'polygon');
        // const basePt = basePoly?.ref?.points?.[0] ?? [0, 0];
        // const objPt  = obj.ref.points?.[0] ?? [0, 0];

        // const offsetX = this.lastClickForPaste.x - basePt[0];
        // const offsetY = this.lastClickForPaste.y - basePt[1];

        const newPoints = obj.ref.points.map(([px, py]) => ([
          this.snapToGrid(px + pasteOffsetX),
          this.snapToGrid(py + pasteOffsetY)
        ]));

        const layer = layerLibrary.getLayerById(obj.ref.layerId) || {};

        const newPolygon = {
          id: crypto.randomUUID(),
          type: 'polygon',

          // geometry
          points: newPoints,

          // 🔥 normalized layer identity
          layerId:
            layer.id ??
            obj.ref.layerId ??
            `${obj.ref.layerNumber ?? 1}:${obj.ref.datatypeNumber ?? 0}`,

          layerNumber: layer.layerNumber ?? obj.ref.layerNumber ?? 1,
          datatypeNumber: layer.datatypeNumber ?? obj.ref.datatypeNumber ?? 0,
          layer: layer.layerNumber ?? obj.ref.layerNumber ?? 1,
          datatype: layer.datatypeNumber ?? obj.ref.datatypeNumber ?? 0,

          // visuals
          stroke: layer.color ?? obj.ref.stroke,
          fill: layer.color
            ? layer.color.replace('rgb', 'rgba').replace(')', ',0.3)')
            : obj.ref.fill,

          // state
          visible: true,
          locked: false,
          opacity: obj.ref.opacity
        };

        // ✅ ONLY write via polygonLibrary → created cell
        polygonLibrary.addPolygon(cellName, newPolygon);

        // 🔑 fetch live reference
        const createdCell = layoutEngine.getCellByName(cellName);
        const liveRef = createdCell?.elements?.find(e => e.id === newPolygon.id);

        if (liveRef) {
          newObjects.push({
            id: liveRef.id,
            type: 'polygon',
            ref: liveRef,
            isUploaded: false
          });
        }
      }






      //       else if (obj.type === 'polygon') {

      //   // 🔴 UPLOADED (GDS) POLYGON
      //   if (obj.isUploaded) {
      //     const uploadedCell = layoutEngine.getUploadedCell(cellName);
      //     if (!uploadedCell) return;

      //     polygonLibrary.ensureCreatedCell(cellName);

      //     const basePoint = this.copiedObjects[0].ref.points?.[0] || [0, 0];
      //     const objBasePoint = obj.ref.points?.[0] || [0, 0];

      //     const dx = objBasePoint[0] - basePoint[0];
      //     const dy = objBasePoint[1] - basePoint[1];

      //     const offsetX = this.lastClickForPaste.x + dx - objBasePoint[0];
      //     const offsetY = this.lastClickForPaste.y + dy - objBasePoint[1];

      //     const newPoints = (obj.ref.points || []).map(([px, py]) => ([
      //       this.snapToGrid(px + offsetX),
      //       this.snapToGrid(py + offsetY)
      //     ]));

      //     const layer = layerLibrary.getLayerById(obj.ref.layerId);

      //     const newPolygon = {
      //       ...obj.ref,
      //       id: crypto.randomUUID(),
      //       points: newPoints,
      //       visible: true,

      //       stroke: layer?.color || obj.ref.stroke,
      //       fill: layer?.color
      //         ? layer.color.replace("rgb", "rgba").replace(")", ",0.3)")
      //         : obj.ref.fill,
      //     };

      //     uploadedCell.elements.push(newPolygon);

      //     newObjects.push({
      //       id: newPolygon.id,
      //       type: 'polygon',
      //       ref: newPolygon,
      //       isUploaded: true
      //     });
      //   }

      //   // 🟢 CREATED POLYGON (existing logic)
      //   else {
      //     const newId = Date.now() + Math.random();

      //     const basePoint = this.copiedObjects[0].ref.points?.[0] || [0, 0];
      //     const objBasePoint = obj.ref.points?.[0] || [0, 0];

      //     const dx = objBasePoint[0] - basePoint[0];
      //     const dy = objBasePoint[1] - basePoint[1];

      //     const offsetX = this.lastClickForPaste.x + dx - objBasePoint[0];
      //     const offsetY = this.lastClickForPaste.y + dy - objBasePoint[1];

      //     const newPoints = obj.ref.points.map(([px, py]) => ([
      //       this.snapToGrid(px + offsetX),
      //       this.snapToGrid(py + offsetY)
      //     ]));

      //     const layer = layerLibrary.getLayerById(obj.ref.layerId) || {};

      //     const newPolygon = {
      //       ...obj.ref,
      //       id: newId,
      //       points: newPoints,
      //       layerId: layer.id,
      //       layerName: layer.name,
      //       layerNumber: layer.layerNumber,
      //       datatypeNumber: layer.datatypeNumber,
      //       datatypeName: layer.datatypeName,
      //       stroke: layer.color,
      //       fill: layer.color.replace("rgb", "rgba").replace(")", ",0.3)"),
      //     };

      //     polygonLibrary.addPolygon(cellName, newPolygon);

      //     const updatedCell = layoutEngine.getCellByName(cellName);
      //     const liveRef = updatedCell?.elements?.find(e => e.id === newId);

      //     if (liveRef) {
      //       newObjects.push({
      //         id: newId,
      //         type: 'polygon',
      //         ref: liveRef,
      //         isUploaded: false
      //       });
      //     }
      //   }
      // }

    }

    this.selectedObjects = newObjects;
    selectionLibrary.setSelection(newObjects);
    this.draw();

    console.log("📥 Pasted copied objects and fixed live references");
  }





  advancedPaste(rows, cols, startX, startY, rowSpacing, colSpacing) {
    if (!this.copiedObjects?.length) return;
    this.recordState();

    const cellName = ProjectManager.getSelectedCell();
    const newObjects = [];

    // --- 🧩 Compute bounding box of copied objects for consistent spacing
    const allPoints = [];

    for (const obj of this.copiedObjects) {
      if (obj.type === "rectangle") {
        const { x, y, width, height } = obj.ref;
        allPoints.push([x, y], [x + width, y + height]);
      } else if (obj.type === "label" || obj.type === "instance") {
        const { x, y } = obj.ref;
        allPoints.push([x, y]);
      } else if (obj.type === "polygon" && Array.isArray(obj.ref.points)) {
        for (const [px, py] of obj.ref.points) {
          if (Number.isFinite(px) && Number.isFinite(py)) {
            allPoints.push([px, py]);
          }
        }
      }
    }

    const minX = Math.min(...allPoints.map(p => p[0]));
    const minY = Math.min(...allPoints.map(p => p[1]));
    const maxX = Math.max(...allPoints.map(p => p[0]));
    const maxY = Math.max(...allPoints.map(p => p[1]));

    const boundingWidth = maxX - minX;
    const boundingHeight = maxY - minY;

    // --- 🧮 Compute spacing offset per cell
    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {
        const offsetX = c * (boundingWidth + colSpacing);
        const offsetY = r * (boundingHeight + rowSpacing);

        for (let obj of this.copiedObjects) {
          // if (obj.type === "rectangle") {
          //   const newId = Date.now() + Math.random();
          //   const x = this.snapToGrid(obj.ref.x + startX + offsetX);
          //   const y = this.snapToGrid(obj.ref.y + startY + offsetY);
          //   const newRect = { ...obj.ref, id: newId, x, y, selected: false };

          //   InstanceLibrary.addRectangle(
          //     cellName,
          //     newRect.layerId,
          //     x,
          //     y,
          //     newRect.width,
          //     newRect.height,
          //     newRect
          //   );

          //   const rectsInLayer = InstanceLibrary.getAllInstances()[newRect.layerId] || [];
          //   const liveRef = rectsInLayer.find(r => r.id === newId);
          //   if (liveRef) newObjects.push({ id: newId, type: "rectangle", ref: liveRef });

          // }
          if (obj.type === "rectangle") {

            // 🔴 UPLOADED (GDS) RECTANGLE
            if (obj.isUploaded) {
              const uploadedCell = layoutEngine.getUploadedCell(cellName);
              // ✅ DEFINE layer (this was missing)
              const layer = layerLibrary.getLayerById(obj.ref.layerId) || {};

              const newRect = {
                ...obj.ref,
                id: crypto.randomUUID(),
                x: this.snapToGrid(obj.ref.x + startX + offsetX),
                y: this.snapToGrid(obj.ref.y + startY + offsetY),

                // ✅ style fix
                // stroke: obj.ref.stroke || '#00ffff',
                // fill: obj.ref.fill || 'rgba(0,255,255,0.3)',
                // ✅ use layer color first
                stroke: layer.color ?? obj.ref.stroke,
                fill: layer.color
                  ? layer.color.replace("rgb", "rgba").replace(")", ",0.3)")
                  : obj.ref.fill,
                visible: true,
              };

              uploadedCell.elements.push(newRect);

              newObjects.push({
                id: newRect.id,
                type: "rectangle",
                ref: newRect,
                isUploaded: true
              });
            }

            // 🟢 CREATED RECTANGLE
            else {
              const newId = Date.now() + Math.random();

              const x = this.snapToGrid(obj.ref.x + startX + offsetX);
              const y = this.snapToGrid(obj.ref.y + startY + offsetY);

              // const newRect = {
              //   ...obj.ref,
              //   id: newId,
              //   x,
              //   y,
              //   selected: false
              // };
              const layer = layerLibrary.getLayerById(obj.ref.layerId);

              const newRect = {
                ...obj.ref,
                id: crypto.randomUUID(),
                x: this.snapToGrid(obj.ref.x + startX + offsetX),
                y: this.snapToGrid(obj.ref.y + startY + offsetY),
                visible: true,

                stroke: layer?.color || obj.ref.stroke,
                fill: layer?.color
                  ? layer.color.replace("rgb", "rgba").replace(")", ",0.3)")
                  : obj.ref.fill,
              };

              InstanceLibrary.addRectangle(
                cellName,
                newRect.layerId,
                x,
                y,
                newRect.width,
                newRect.height,
                newRect
              );

              const rectsInLayer =
                InstanceLibrary.getAllInstances()[newRect.layerId] || [];

              const liveRef = rectsInLayer.find(r => r.id === newId);

              if (liveRef) {
                newObjects.push({
                  id: newId,
                  type: "rectangle",
                  ref: liveRef,
                  isUploaded: false
                });
              }
            }
          }

          else if (obj.type === "label") {
            const x = this.snapToGrid(obj.ref.x + startX + offsetX);
            const y = this.snapToGrid(obj.ref.y + startY + offsetY);
            const newLabel = labelLibrary.addLabel(
              cellName,
              obj.ref.layerId,
              x,
              y,
              obj.ref.text,
              obj.ref.color
            );
            newObjects.push({ id: newLabel.id, type: "label", ref: newLabel });

          } else if (obj.type === "instance") {

            const baseInst = obj.ref;

            // 🔐 normalize once (important for both paths)
            const normalized = {
              ...baseInst,
              id: crypto.randomUUID(),

              x: this.snapToGrid(baseInst.x + startX + offsetX),
              y: this.snapToGrid(baseInst.y + startY + offsetY),

              level: Number.isFinite(baseInst.level) ? baseInst.level : 0,
              rotation: baseInst.rotation || 0,
              scale: baseInst.scale || 1,

              mirror_x: !!baseInst.mirror_x,
              mirror_y: !!baseInst.mirror_y,
            };

            // 🔴 UPLOADED INSTANCE → stay in uploaded cell
            if (obj.isUploaded) {
              const uploadedCell = layoutEngine.getUploadedCell(cellName);

              if (!uploadedCell) {
                console.warn("❌ AdvancedPaste: uploaded cell not found");
                continue;
              }

              uploadedCell.instances = uploadedCell.instances || [];
              uploadedCell.instances.push(normalized);

              newObjects.push({
                id: normalized.id,
                type: "instance",
                ref: normalized,
                isUploaded: true
              });
            }

            // 🟢 CREATED INSTANCE → go through layoutEngine
            else {
              layoutEngine.addInstance(
                cellName,
                normalized.ref,   // referenced cell name
                normalized.x,
                normalized.y,
                normalized
              );

              // 🔑 get LIVE reference from created cell
              const createdCell = layoutEngine.getCellByName(cellName);
              const liveRef = createdCell?.instances?.find(i => i.id === normalized.id);

              if (liveRef) {
                newObjects.push({
                  id: liveRef.id,
                  type: "instance",
                  ref: liveRef,
                  isUploaded: false
                });
              }
            }
          }

          // else if (obj.type === "polygon") {
          //   const newId = Date.now() + Math.random();
          //   const newPoints = obj.ref.points
          //     .filter(pt => Array.isArray(pt) && pt.length === 2 && Number.isFinite(pt[0]) && Number.isFinite(pt[1]))
          //     .map(([px, py]) => [
          //       this.snapToGrid(px + startX + offsetX),
          //       this.snapToGrid(py + startY + offsetY)
          //     ]);

          //   const layer = layerLibrary.getLayerById(obj.ref.layerId) || {
          //     id: "unknown",
          //     name: "NW",
          //     layerNumber: "1",
          //     datatypeNumber: "0",
          //     datatypeName: "drawing",
          //     color: "#F96109",
          //   };

          //   const newPolygon = {
          //     ...obj.ref,
          //     id: newId,
          //     points: newPoints,
          //     selected: false,
          //     layerId: layer.id,
          //     layerName: layer.name,
          //     layerNumber: layer.layerNumber,
          //     datatypeNumber: layer.datatypeNumber,
          //     datatypeName: layer.datatypeName,
          //     stroke: layer.color,
          //     fill: layer.color.replace("rgb", "rgba").replace(")", ",0.3)"),
          //   };

          //   polygonLibrary.addPolygon(cellName, newPolygon);
          //   const updatedCell = layoutEngine.getCellByName(cellName);
          //   const liveRef = updatedCell?.elements?.find(e => e.id === newId);
          //   if (liveRef) newObjects.push({ id: newId, type: "polygon", ref: liveRef });
          // }
          else if (obj.type === "polygon") {
            // ✅ ensure writable cell (ONLY addition)
            polygonLibrary.ensureCreatedCell(cellName);

            const newId = crypto.randomUUID();

            const newPoints = obj.ref.points
              .filter(pt => Array.isArray(pt) && pt.length === 2 && Number.isFinite(pt[0]) && Number.isFinite(pt[1]))
              .map(([px, py]) => [
                this.snapToGrid(px + startX + offsetX),
                this.snapToGrid(py + startY + offsetY)
              ]);

            const layer = layerLibrary.getLayerById(obj.ref.layerId) || {
              id: obj.ref.layerId,
              layerNumber: obj.ref.layerNumber ?? 1,
              datatypeNumber: obj.ref.datatypeNumber ?? 0,
              color: obj.ref.stroke ?? "#F96109",
            };

            const newPolygon = {
              ...obj.ref,
              id: newId,
              type: "polygon",           // 🔑 important
              points: newPoints,
              selected: false,
              visible: true,
              locked: false,

              layerId: layer.id,
              layerNumber: layer.layerNumber,
              datatypeNumber: layer.datatypeNumber,

              stroke: layer.color,
              fill: layer.color.replace("rgb", "rgba").replace(")", ",0.3)")
            };

            polygonLibrary.addPolygon(cellName, newPolygon);

            const updatedCell = layoutEngine.getCellByName(cellName);
            const liveRef = updatedCell?.elements?.find(e => e.id === newId);

            if (liveRef) {
              newObjects.push({
                id: newId,
                type: "polygon",
                ref: liveRef,
                isUploaded: false   // 🔑 uploaded → created
              });
            }
          }



        }
      }
    }

    // --- ✅ Finalize selection
    this.selectedObjects = newObjects;
    selectionLibrary.setSelection(newObjects);
    this.draw();

    console.log(`📥 Advanced pasted ${newObjects.length} objects in a ${rows}x${cols} grid (end-to-start spacing)`);
  }
  // advancedPaste(rows, cols, startX, startY, rowSpacing, colSpacing) {
  //   if (!this.copiedObjects?.length) return;
  //   this.recordState();

  //   const cellName = ProjectManager.getSelectedCell();
  //   if (!cellName) return;

  //   // 🔑 ALWAYS work in a created cell
  //   polygonLibrary.ensureCreatedCell(cellName);

  //   const newObjects = [];

  //   // --- compute bounding box
  //   const allPoints = [];
  //   for (const obj of this.copiedObjects) {
  //     if (obj.type === "rectangle") {
  //       const { x, y, width, height } = obj.ref;
  //       allPoints.push([x, y], [x + width, y + height]);
  //     } else if (obj.type === "label" || obj.type === "instance") {
  //       allPoints.push([obj.ref.x, obj.ref.y]);
  //     } else if (obj.type === "polygon") {
  //       obj.ref.points?.forEach(p => allPoints.push(p));
  //     }
  //   }

  //   const minX = Math.min(...allPoints.map(p => p[0]));
  //   const minY = Math.min(...allPoints.map(p => p[1]));
  //   const maxX = Math.max(...allPoints.map(p => p[0]));
  //   const maxY = Math.max(...allPoints.map(p => p[1]));

  //   const boundingWidth = maxX - minX;
  //   const boundingHeight = maxY - minY;

  //   // --- grid paste
  //   for (let r = 0; r < rows; r++) {
  //     for (let c = 0; c < cols; c++) {
  //       const dx = c * (boundingWidth + colSpacing) + startX;
  //       const dy = r * (boundingHeight + rowSpacing) + startY;

  //       for (const obj of this.copiedObjects) {

  //         /* ===================== RECTANGLE ===================== */
  //         if (obj.type === "rectangle") {
  //           const layer = layerLibrary.getLayerById(obj.ref.layerId) || {};
  //           const newRect = {
  //             ...obj.ref,
  //             id: crypto.randomUUID(),
  //             x: this.snapToGrid(obj.ref.x + dx),
  //             y: this.snapToGrid(obj.ref.y + dy),
  //             visible: true,
  //             stroke: layer.color ?? obj.ref.stroke,
  //             fill: layer.color
  //               ? layer.color.replace("rgb", "rgba").replace(")", ",0.3)")
  //               : obj.ref.fill,
  //           };

  //           InstanceLibrary.addRectangle(
  //             cellName,
  //             newRect.layerId,
  //             newRect.x,
  //             newRect.y,
  //             newRect.width,
  //             newRect.height,
  //             newRect
  //           );

  //           // const rects =
  //           //   InstanceLibrary.getAllInstances()[cellName]?.flat() || [];
  //           const rects =
  //   Object.values(InstanceLibrary.getAllInstances()[cellName] || {}).flat();

  //           const liveRef = rects.find(r => r.id === newRect.id);

  //           if (liveRef) {
  //             newObjects.push({
  //               id: liveRef.id,
  //               type: "rectangle",
  //               ref: liveRef,
  //               isUploaded: false
  //             });
  //           }
  //         }

  //         /* ===================== LABEL ===================== */
  //         else if (obj.type === "label") {
  //           const x = this.snapToGrid(obj.ref.x + dx);
  //           const y = this.snapToGrid(obj.ref.y + dy);
  //           const newLabel = labelLibrary.addLabel(
  //             cellName,
  //             obj.ref.layerId,
  //             x,
  //             y,
  //             obj.ref.text,
  //             obj.ref.color
  //           );
  //           newObjects.push({ id: newLabel.id, type: "label", ref: newLabel });
  //         }

  //         /* ===================== INSTANCE ===================== */
  //         else if (obj.type === "instance") {
  //           layoutEngine.addInstance(
  //             cellName,
  //             obj.ref.ref,
  //             obj.ref.x + dx,
  //             obj.ref.y + dy
  //           );
  //         }

  //         /* ===================== POLYGON ===================== */
  //         else if (obj.type === "polygon") {
  //           const layer = layerLibrary.getLayerById(obj.ref.layerId) || {};
  //           const newPolygon = {
  //             id: crypto.randomUUID(),
  //             type: "polygon",
  //             points: obj.ref.points.map(([px, py]) => ([
  //               this.snapToGrid(px + dx),
  //               this.snapToGrid(py + dy)
  //             ])),
  //             layerId:
  //               layer.id ??
  //               obj.ref.layerId ??
  //               `${obj.ref.layerNumber ?? 1}:${obj.ref.datatypeNumber ?? 0}`,
  //             layerNumber: layer.layerNumber ?? obj.ref.layerNumber ?? 1,
  //             datatypeNumber: layer.datatypeNumber ?? obj.ref.datatypeNumber ?? 0,
  //             stroke: layer.color ?? obj.ref.stroke,
  //             fill: layer.color
  //               ? layer.color.replace("rgb", "rgba").replace(")", ",0.3)")
  //               : obj.ref.fill,
  //             visible: true,
  //             locked: false
  //           };

  //           polygonLibrary.addPolygon(cellName, newPolygon);

  //           const cell = layoutEngine.getCellByName(cellName);
  //           const liveRef = cell?.elements?.find(e => e.id === newPolygon.id);

  //           if (liveRef) {
  //             newObjects.push({
  //               id: liveRef.id,
  //               type: "polygon",
  //               ref: liveRef,
  //               isUploaded: false
  //             });
  //           }
  //         }
  //       }
  //     }
  //   }

  //   // --- finalize selection
  //   this.selectedObjects = newObjects;
  //   selectionLibrary.setSelection(newObjects);
  //   this.draw();

  //   console.log(
  //     `📥 Advanced pasted ${newObjects.length} objects in ${rows}x${cols} grid`
  //   );
  // }











  deleteSelectedObjects() {
    this.recordState();
    if (!this.selectedObjects?.length) return;

    const cellName = ProjectManager.getSelectedCell();

    for (let obj of this.selectedObjects) {
      const item = obj.ref;
      if (obj.type === 'rectangle') {
        if (item.locked) {
          return
        }
        if (obj.isUploaded) {
          // Handle uploaded rectangle deletion
          const uploadedCell = layoutEngine.getUploadedCell(cellName);
          if (uploadedCell) {
            uploadedCell.elements = uploadedCell.elements.filter(el => el.id !== obj.id);
          }
        } else {
          // Existing created rectangle handling
          InstanceLibrary.deleteRectangle(cellName, obj.ref.layerId, obj.ref.id);
          layoutEngine.deleteElement(cellName, obj.ref.id);
        }
      }
      else if (obj.type === 'label' && !obj.ref.locked) {
        labelLibrary.deleteLabel(cellName, obj.ref.layerId, obj.ref.id);
        layoutEngine.deleteElement(cellName, obj.ref.id);
      }
      else if (obj.type === 'instance') {
        const inst = obj.ref;
        if (isLocked(inst.ref)) {
          console.log(`🔒 Instance of locked cell "${inst.ref}" cannot be delete.`);
          return;
        }

        if (obj.isUploaded) {
          // Handle uploaded instance deletion
          const uploadedCell = layoutEngine.getUploadedCell(cellName);
          if (uploadedCell) {
            uploadedCell.instances = uploadedCell.instances.filter(inst => inst.id !== obj.id);
          }
        } else {
          // Existing created instance handling
          const currentCell = layoutEngine.getCellByName(cellName);
          if (currentCell) {
            currentCell.instances = currentCell.instances.filter(inst => inst.id !== obj.id);
          }
        }
        if (hasPlacedPCell(inst.ref)) {
          removePlacedPCell(inst.ref);
          usePlacementStore.getState().removePattern(inst.ref);
          layoutEngine.deleteCell?.(inst.ref);

          if (ProjectManager.getSelectedInstanceCell?.() === inst.ref) {
            ProjectManager.setSelectedInstanceCell?.("");
            clearActiveDraftPCell?.();
          }

          console.log(`🧹 Fully removed PCell "${inst.ref}" from hierarchy/store`);
        }
        window.dispatchEvent(new Event("hierarchy-updated"));
      }
      else if (obj.type === 'polygon') {
        if (item.locked) {
          return
        }
        polygonLibrary.deletePolygon(cellName, obj.ref.id);
      }
    }

    this.selectedObjects = [];
    selectionLibrary.clearSelection();
    this.refreshParametricDotsAfterMutation(cellName);
    this.draw();
    console.log("🗑️ Deleted selected objects (including uploaded)");
  }





  rotateSelectedObjects(degrees) {
    if (!this.selectedObjects?.length) return;
    this.recordState();
    const seen = new Set(); // key by type+id/ref

    for (let obj of this.selectedObjects) {
      if (!obj || !obj.ref) continue;

      // unique key (id available ho to use karo)
      const key = `${obj.type}:${obj.ref.id ?? obj.id ?? (obj.ref._uid || obj.ref)}`;
      if (seen.has(key)) continue;
      seen.add(key);

      if (obj.type === 'rectangle' && !obj.ref.locked) {
        const rect = obj.ref;
        const cx = rect.x + rect.width / 2;
        const cy = rect.y + rect.height / 2;

        let newRotation = (rect.rotation || 0) + degrees;
        newRotation = ((newRotation % 360) + 360) % 360;
        rect.rotation = newRotation;

        if (newRotation === 90 || newRotation === 270) {
          const t = rect.width; rect.width = rect.height; rect.height = t;
        }
        rect.x = cx - rect.width / 2;
        rect.y = cy - rect.height / 2;
      }

      else if (obj.type === 'label' && !obj.ref.locked) {
        const cur = obj.ref.rotation || 0;
        let next = cur + degrees;
        next = ((next % 360) + 360) % 360;
        obj.ref.rotation = next;
      }

      else if (obj.type === 'polygon' && !obj.ref.locked) {
        const poly = obj.ref;
        const pts = Array.isArray(poly.points) ? poly.points : [];
        if (pts.length >= 3) {
          let cx = 0, cy = 0;
          for (const p of pts) { const x = Array.isArray(p) ? p[0] : p.x; const y = Array.isArray(p) ? p[1] : p.y; cx += x; cy += y; }
          cx /= pts.length; cy /= pts.length;

          const rad = (degrees * Math.PI) / 180, cos = Math.cos(rad), sin = Math.sin(rad);
          poly.points = pts.map(p => {
            const x = Array.isArray(p) ? p[0] : p.x, y = Array.isArray(p) ? p[1] : p.y;
            const dx = x - cx, dy = y - cy;
            const nx = cx + dx * cos - dy * sin;
            const ny = cy + dx * sin + dy * cos;
            return Array.isArray(p) ? [Math.round(nx), Math.round(ny)] : { x: Math.round(nx), y: Math.round(ny) };
          });
        }
      }

      else if (obj.type === 'instance' && !obj.ref.locked &&
        !isLocked(obj.ref.ref)) {
        const inst = obj.ref;
        let newRotation = (inst.rotation || 0) + degrees;
        newRotation = ((newRotation % 360) + 360) % 360;
        inst.rotation = newRotation;

        const cellName = ProjectManager.getSelectedCell();
        const uploadedCell = layoutEngine.getUploadedCell(cellName);
        if (uploadedCell?.instances) {
          const match = uploadedCell.instances.find(i => i.id === inst.id);
          if (match) match.rotation = newRotation;
        }
        const currentCell = layoutEngine.getCellByName(cellName);
        if (currentCell?.instances) {
          const match2 = currentCell.instances.find(i => i.id === inst.id);
          if (match2) match2.rotation = newRotation;
        }
      }
    }

    this.draw();
    console.log(`🔄 Rotated selected objects by ${degrees}°`);
  }



  startDrag(e) {

    if (!this.selectedObjects?.length) return;

    const x = (e.offsetX - this.offsetX) / this.scale;
    const y = (e.offsetY - this.offsetY) / this.scale;

    this.pendingRecordState = false;

    // Check if clicked inside any selected object
    for (let obj of this.selectedObjects) {
      const item = obj.ref;

      // Handle both created and uploaded rectangles
      if (obj.type === 'rectangle') {
        // Fallbacks for missing values
        const x1 = item.x ?? item.x1 ?? 0;
        const y1 = item.y ?? item.y1 ?? 0;
        const x2 = item.x2 ?? (item.x !== undefined ? item.x + item.width : x1 + (item.width ?? 0));
        const y2 = item.y2 ?? (item.y !== undefined ? item.y + item.height : y1 + (item.height ?? 0));
        const left = Math.min(x1, x2);
        const right = Math.max(x1, x2);
        const top = Math.min(y1, y2);
        const bottom = Math.max(y1, y2);

        if ((item.locked ?? false) === true) return;

        if (x >= left && x <= right && y >= top && y <= bottom) {
          this.pendingRecordState = true;
          this.dragStart = { x, y };
          this.initialPositions = this.selectedObjects.map(obj => ({
            id: obj.id,
            type: obj.type,
            startX: obj.ref.x ?? obj.ref.x1 ?? 0,
            startY: obj.ref.y ?? obj.ref.y1 ?? 0
          }));
          this.isDragging = true;
          return;
        }
      }

      else if (obj.type === 'label') {
        if (item.locked) {
          console.log('🔒 Cannot drag locked label');
          return;
        }

        const bounds = labelLibrary.getDragBoundingBox(item, this.ctx);

        if (x >= bounds.left && x <= bounds.right && y >= bounds.top && y <= bounds.bottom) {
          this.pendingRecordState = true;
          this.dragStart = { x, y };
          this.initialPositions = this.selectedObjects.map(obj => ({
            id: obj.id,
            type: obj.type,
            startX: obj.ref.x,
            startY: obj.ref.y
          }));
          this.isDragging = true;
          return;
        }
      }
      else if (obj.type === 'instance') {
        const inst = obj.ref;

        const refCell = obj.isUploaded
          ? layoutEngine.getUploadedCell(inst.ref)
          : layoutEngine.getCellByName(inst.ref);

        if (!refCell) continue;

        const { offsetX: offsetXInside, offsetY: offsetYInside } = this.getChildBoundingBoxCenterOffset(refCell);

        // for (let el of refCell.elements || []) {
        //   if (el.type !== "rectangle") continue;

        //   const elX1 = el.x ?? el.x1 ?? 0;
        //   const elY1 = el.y ?? el.y1 ?? 0;
        //   const elX2 = el.x2 ?? (elX1 + (el.width ?? 0));
        //   const elY2 = el.y2 ?? (elY1 + (el.height ?? 0));

        //   const globalX1 = inst.x + offsetXInside + Math.min(elX1, elX2);
        //   const globalY1 = inst.y + offsetYInside + Math.min(elY1, elY2);
        //   const globalX2 = inst.x + offsetXInside + Math.max(elX1, elX2);
        //   const globalY2 = inst.y + offsetYInside + Math.max(elY1, elY2);

        //   if (x >= globalX1 && x <= globalX2 && y >= globalY1 && y <= globalY2) {
        //     this.pendingRecordState = true;
        //     this.dragStart = { x, y };
        //     this.initialPositions = this.selectedObjects.map(obj => ({
        //       id: obj.id,
        //       type: obj.type,
        //       startX: obj.ref.x,
        //       startY: obj.ref.y
        //     }));
        //     this.isDragging = true;
        //     return;
        //   }
        // }
        for (let el of refCell.elements || []) {

          // 🔹 RECTANGLE SUPPORT
          if (el.type === "rectangle") {

            const elX1 = el.x ?? el.x1 ?? 0;
            const elY1 = el.y ?? el.y1 ?? 0;
            const elX2 = el.x2 ?? (elX1 + (el.width ?? 0));
            const elY2 = el.y2 ?? (elY1 + (el.height ?? 0));

            const globalX1 = inst.x + offsetXInside + Math.min(elX1, elX2);
            const globalY1 = inst.y + offsetYInside + Math.min(elY1, elY2);
            const globalX2 = inst.x + offsetXInside + Math.max(elX1, elX2);
            const globalY2 = inst.y + offsetYInside + Math.max(elY1, elY2);

            if (x >= globalX1 && x <= globalX2 && y >= globalY1 && y <= globalY2) {
              this.pendingRecordState = true;
              this.dragStart = { x, y };
              this.initialPositions = this.selectedObjects.map(obj => ({
                id: obj.id,
                type: obj.type,
                startX: obj.ref.x,
                startY: obj.ref.y
              }));
              this.isDragging = true;
              return;
            }
          }

          // 🔹 POLYGON SUPPORT (NEW 🔥)
          else if (el.type === "polygon" && Array.isArray(el.points)) {

            const xs = el.points.map(p => p[0]);
            const ys = el.points.map(p => p[1]);

            const minX = Math.min(...xs);
            const maxX = Math.max(...xs);
            const minY = Math.min(...ys);
            const maxY = Math.max(...ys);

            const globalLeft = inst.x + offsetXInside + minX;
            const globalRight = inst.x + offsetXInside + maxX;
            const globalTop = inst.y + offsetYInside + minY;
            const globalBottom = inst.y + offsetYInside + maxY;

            if (x >= globalLeft && x <= globalRight && y >= globalTop && y <= globalBottom) {
              this.pendingRecordState = true;
              this.dragStart = { x, y };
              this.initialPositions = this.selectedObjects.map(obj => ({
                id: obj.id,
                type: obj.type,
                startX: obj.ref.x,
                startY: obj.ref.y
              }));
              this.isDragging = true;
              return;
            }
          }
        }

      }
      else if (obj.type === 'polygon') {
        if (item.locked) {
          console.log('🔒 Cannot drag locked polygon');
          return;
        }
        const pts = item.points;
        if (!pts || pts.length === 0) continue;

        // Simple bounding box check
        const xs = pts.map(p => p[0]);
        const ys = pts.map(p => p[1]);
        const left = Math.min(...xs);
        const right = Math.max(...xs);
        const top = Math.min(...ys);
        const bottom = Math.max(...ys);

        if (x >= left && x <= right && y >= top && y <= bottom) {
          this.pendingRecordState = true;
          this.dragStart = { x, y };
          // this.initialPositions = this.selectedObjects.map(obj => ({
          //   id: obj.id,
          //   type: obj.type,
          //   startPoints: [...obj.ref.points.map(p => [...p])]
          // }));
          this.initialPositions = this.selectedObjects.map(o => {
            if (o.type === 'polygon' && Array.isArray(o.ref.points)) {
              return {
                id: o.id,
                type: o.type,
                startPoints: o.ref.points.map(p => [...p])
              };
            }

            // for rectangle, label, instance
            return {
              id: o.id,
              type: o.type,
              startX: o.ref.x ?? o.ref.x1 ?? 0,
              startY: o.ref.y ?? o.ref.y1 ?? 0
            };
          });

          this.isDragging = true;
          return;
        }
      }

    }
  }

  performDrag(e) {
    if (!this.isDragging || !this.dragStart || !this.initialPositions) return;
    if (this.pendingRecordState) {
      this.recordState();
      this.pendingRecordState = false;
    }

    const x = (e.offsetX - this.offsetX) / this.scale;
    const y = (e.offsetY - this.offsetY) / this.scale;
    const dx = this.snapToGrid(x - this.dragStart.x);
    const dy = this.snapToGrid(y - this.dragStart.y);

    for (let obj of this.selectedObjects) {
      const init = this.initialPositions.find(init => init.id === obj.id && init.type === obj.type);
      if (!init) continue;

      const item = obj.ref;

      if (
        (item.locked ?? false) === true ||
        (obj.type === 'instance' && isLocked(item.ref))
      ) continue;

      // 🔹 Created Rectangle
      if (obj.type === 'rectangle' && 'x' in item) {
        item.x = init.startX + dx;
        item.y = init.startY + dy;

        // ✅ persist in layoutEngine
        const cellName = ProjectManager.getSelectedCell();
        layoutEngine.editElement(cellName, obj.id, {
          x: item.x,
          y: item.y,
          width: item.width,
          height: item.height
        });
      }

      // 🔹 Uploaded Rectangle
      else if (obj.type === 'rectangle' && 'x1' in item && 'x2' in item) {
        const width = Math.abs(item.x2 - item.x1);
        const height = Math.abs(item.y2 - item.y1);
        const xDir = item.x2 > item.x1 ? 1 : -1;
        const yDir = item.y2 > item.y1 ? 1 : -1;

        item.x1 = init.startX + dx;
        item.y1 = init.startY + dy;
        item.x2 = item.x1 + (width * xDir);
        item.y2 = item.y1 + (height * yDir);

        if (obj.isUploaded) {
          const cellName = ProjectManager.getSelectedCell();
          const uploadedCell = layoutEngine.getUploadedCell(cellName);
          if (uploadedCell) {
            const el = uploadedCell.elements.find(el => el.id === obj.id);
            if (el) {
              el.x1 = item.x1;
              el.y1 = item.y1;
              el.x2 = item.x2;
              el.y2 = item.y2;
            }
            // ✅ persist in layoutEngine for non-uploaded too
            const cellName = ProjectManager.getSelectedCell();
            layoutEngine.editElement(cellName, obj.id, {
              x1: item.x1,
              y1: item.y1,
              x2: item.x2,
              y2: item.y2
            });
          }
        }
      }

      // 🔹 Label
      else if (obj.type === 'label') {
        item.x = init.startX + dx;
        item.y = init.startY + dy;
        const cellName = ProjectManager.getSelectedCell();
        layoutEngine.editElement(cellName, obj.id, {
          x: item.x,
          y: item.y,
          text: item.text
        });

      }
      else if (obj.type === 'instance') {
        item.x = init.startX + dx;
        item.y = init.startY + dy;

        const cellName = ProjectManager.getSelectedCell();

        if (obj.isUploaded) {
          const uploadedCell = layoutEngine.getUploadedCell(cellName);
          const match = uploadedCell?.instances?.find(inst => inst.id === obj.id);
          if (match) {
            match.x = item.x;
            match.y = item.y;
          }
        } else {
          const cell = layoutEngine.getCellByName(cellName);
          const match = cell?.instances?.find(inst => inst.id === obj.id);
          if (match) {
            match.x = item.x;
            match.y = item.y;
          }
        }
        // ✅ also persist through editElement for consistency
        // const cellName = ProjectManager.getSelectedCell();
        layoutEngine.editElement(cellName, obj.id, {
          x: item.x,
          y: item.y
        });

      }
      else if (obj.type === 'polygon') {
        const startPts = init.startPoints;
        if (!startPts || startPts.length === 0) continue;

        item.points = startPts.map(([x0, y0]) => [x0 + dx, y0 + dy]);
        // ✅ persist
        const cellName = ProjectManager.getSelectedCell();
        layoutEngine.editElement(cellName, obj.id, {
          points: item.points
        });

      }



    }
    ParametricDotsLibrary.redraw(this);
    ParametricDotsLibrary.applyToEngine(this);
    this.draw();
  }



  stopDrag() {
    this.isDragging = false;
    this.dragStart = null;
    this.initialPositions = null;
  }


  enterMultiMoveMode() {
    if (!this.selectedObjects.length) return;
    this.isMultiMoveMode = true;
    this.isDragging = false; // ❌ Not dragging immediately
    console.log("🚀 Multi-Move Mode READY (waiting for click)");
  }


  startMultiMoveFromClick(e) {
    this.recordState();
    if (!this.isMultiMoveMode) return;

    const pointerX = (e.offsetX - this.offsetX) / this.scale;
    const pointerY = (e.offsetY - this.offsetY) / this.scale;

    this.dragStart = { x: pointerX, y: pointerY };
    this.initialPositions = this.selectedObjects.map(obj => ({
      id: obj.id,
      type: obj.type,
      startX: obj.ref.x,
      startY: obj.ref.y
    }));

    this.isDragging = true;
    this.isMultiMoveMode = false; // ✅ Click ke baad mode off
    console.log("🎯 Multi-Move STARTED from click:", this.dragStart);
  }

  updateMultiMoveFollow(e) {
    if (!this.isDragging || !this.initialPositions) return;

    const x = (e.offsetX - this.offsetX) / this.scale;
    const y = (e.offsetY - this.offsetY) / this.scale;

    const dx = this.snapToGrid(x - this.dragStart.x);
    const dy = this.snapToGrid(y - this.dragStart.y);

    for (let obj of this.selectedObjects) {
      const init = this.initialPositions.find(init => init.id === obj.id && init.type === obj.type);
      if (init) {
        obj.ref.x = init.startX + dx;
        obj.ref.y = init.startY + dy;
      }
    }

    this.draw();
  }

  exitMultiMoveMode() {
    this.isMultiMoveMode = false;
    this.isDragging = false;

    const cellName = ProjectManager.getSelectedCell();

    for (let obj of this.selectedObjects) {
      if (!obj.ref?.x || !obj.ref?.y) continue;

      layoutEngine.editElement(cellName, obj.id, {
        x: obj.ref.x,
        y: obj.ref.y
      });
    }

    this.dragStart = null;
    this.initialPositions = null;

    console.log("🛑 Multi-Move Mode OFF (saved to layoutEngine)");
  }



  // recordState() {
  //   const state = {
  //     rectangles: JSON.parse(JSON.stringify(InstanceLibrary.getAllInstances() || {})),
  //     labels: JSON.parse(JSON.stringify(labelLibrary.getAllLabelMap() || {})),
  //     polygons: JSON.parse(JSON.stringify(polygonLibrary.getAllPolygonMap() || {})),
  //     instances: JSON.parse(JSON.stringify(layoutEngine.getAllCellsMap() || {}))
  //   };
  //   this.history.push(state);
  //   this.future = []; // clear redo stack
  // }

  // restoreState(state) {
  //   if (!state) return;

  //   InstanceLibrary.setAllInstances(state.rectangles || {});
  //   labelLibrary.setAllLabels(state.labels || {});
  //   polygonLibrary.setAllPolygons(state.polygons);
  //   layoutEngine.setAllCells(state.instances);

  //   // clear selection after restore
  //   // this.selectedObjects = [];
  //   // selectionLibrary.clearSelection();
  //   this.draw();
  // }
  recordState() {
    const state = {
      rectangles: JSON.parse(JSON.stringify(InstanceLibrary.getAllInstances() || {})),
      labels: JSON.parse(JSON.stringify(labelLibrary.getAllLabelMap() || {})),
      polygons: JSON.parse(JSON.stringify(polygonLibrary.getAllPolygonMap() || {})),
      // Store BOTH arrays separately
      createdCells: JSON.parse(JSON.stringify(layoutEngine.getCells() || [])),
      uploadedCells: JSON.parse(JSON.stringify(layoutEngine.getUploadedCells() || []))
    };
    this.history.push(state);
    this.future = [];
  }

  restoreState(state) {
    if (!state) return;

    InstanceLibrary.setAllInstances(state.rectangles || {});
    labelLibrary.setAllLabels(state.labels || {});
    polygonLibrary.setAllPolygons(state.polygons);

    // Restore both arrays separately
    if (state.createdCells) {
      // Clear and restore created cells
      const currentCreated = layoutEngine.getCells();
      currentCreated.forEach(cell => {
        const restored = state.createdCells.find(c => c.name === cell.name);
        if (restored) {
          cell.elements = [...(restored.elements || [])];
          cell.instances = [...(restored.instances || [])];
        }
      });
    }

    if (state.uploadedCells) {
      layoutEngine.setUploadedCells(state.uploadedCells);
    }

    this.draw();
  }

  undo() {
    if (!this.history.length) return;

    const currentState = {
      rectangles: JSON.parse(JSON.stringify(InstanceLibrary.getAllInstances() || {})),
      labels: JSON.parse(JSON.stringify(labelLibrary.getAllLabelMap() || {})),
      polygons: JSON.parse(JSON.stringify(polygonLibrary.getAllPolygonMap() || {})),
      instances: JSON.parse(JSON.stringify(layoutEngine.getAllCellsMap() || {}))
    };
    this.future.push(currentState);

    const prevState = this.history.pop();
    this.restoreState(prevState);
    window.dispatchEvent(new CustomEvent("hierarchy-updated"));
    console.log("↩️ Undo");
  }

  undo() {
    if (!this.history.length) return;

    const currentState = {
      rectangles: JSON.parse(JSON.stringify(InstanceLibrary.getAllInstances() || {})),
      labels: JSON.parse(JSON.stringify(labelLibrary.getAllLabelMap() || {})),
      polygons: JSON.parse(JSON.stringify(polygonLibrary.getAllPolygonMap() || {})),
      createdCells: JSON.parse(JSON.stringify(layoutEngine.getCells() || [])),
      uploadedCells: JSON.parse(JSON.stringify(layoutEngine.getUploadedCells() || []))
    };

    this.future.push(currentState);
    const prevState = this.history.pop();
    this.restoreState(prevState);

    window.dispatchEvent(new CustomEvent("hierarchy-updated"));
    console.log("↩️ Undo");
  }


  redo() {
    if (!this.future.length) return;

    const currentState = {
      rectangles: JSON.parse(JSON.stringify(InstanceLibrary.getAllInstances() || {})),
      labels: JSON.parse(JSON.stringify(labelLibrary.getAllLabelMap() || {})),
      polygons: JSON.parse(JSON.stringify(polygonLibrary.getAllPolygonMap() || {})),
      // instances: JSON.parse(JSON.stringify(layoutEngine.getAllCellsMap() || {}))
      createdCells: JSON.parse(JSON.stringify(layoutEngine.getCells() || [])),
      uploadedCells: JSON.parse(JSON.stringify(layoutEngine.getUploadedCells() || []))
    };
    this.history.push(currentState);

    const nextState = this.future.pop();
    this.restoreState(nextState);
    window.dispatchEvent(new CustomEvent("hierarchy-updated"));
    console.log("↪️ Redo");
  }

  // end shiv updated functions
  isNear(p1, p2, margin = 5) {
    return Math.abs(p1 - p2) <= margin;
  }


  normalizeRectForResize(rect) {
    // Case 1: uploaded GDS rectangle (x1/y1/x2/y2)
    if (
      rect.x1 !== undefined &&
      rect.y1 !== undefined &&
      rect.x2 !== undefined &&
      rect.y2 !== undefined
    ) {
      const left = Math.min(rect.x1, rect.x2);
      const right = Math.max(rect.x1, rect.x2);
      const top = Math.min(rect.y1, rect.y2);
      const bottom = Math.max(rect.y1, rect.y2);

      rect.x = left;
      rect.y = top;
      rect.width = right - left;
      rect.height = bottom - top;
      return;
    }

    // Case 2: created rectangle but width/height may be negative
    if (
      rect.x !== undefined &&
      rect.y !== undefined &&
      rect.width !== undefined &&
      rect.height !== undefined
    ) {
      if (rect.width < 0) {
        rect.x += rect.width;
        rect.width = Math.abs(rect.width);
      }
      if (rect.height < 0) {
        rect.y += rect.height;
        rect.height = Math.abs(rect.height);
      }
      return;
    }

    // Fallback safety
    rect.x = rect.x ?? 0;
    rect.y = rect.y ?? 0;
    rect.width = Math.abs(rect.width ?? 0);
    rect.height = Math.abs(rect.height ?? 0);
  }



  // checkResizeCursor(e) {
  //   const x = (e.offsetX - this.offsetX) / this.scale;
  //   const y = (e.offsetY - this.offsetY) / this.scale;

  //   this.resizeTarget = null;
  //   this.resizeEdge = null;

  //   const selectedRects = this.selectedObjects.filter(obj => obj.type === 'rectangle').map(obj => obj.ref);
  //   const margin = 5 / this.scale;

  //   // First check if we're hovering over a locked element
  //   for (let obj of this.selectedObjects) {
  //     if (obj.ref?.locked) {
  //       return; // Skip all resize checks if any selected element is locked
  //     }
  //   }


  //   for (let rect of selectedRects) {
  //      this.normalizeRectForResize(rect);
  //     const left = rect.x;
  //     const right = rect.x + rect.width;
  //     const top = rect.y;
  //     const bottom = rect.y + rect.height;

  //     if (this.isNear(x, left, margin) && this.isNear(y, top, margin)) {
  //       this.canvas.style.cursor = "nwse-resize";
  //       this.resizeTarget = rect;
  //       this.resizeEdge = "top-left";
  //       return;
  //     }
  //     if (this.isNear(x, right, margin) && this.isNear(y, top, margin)) {
  //       this.canvas.style.cursor = "nesw-resize";
  //       this.resizeTarget = rect;
  //       this.resizeEdge = "top-right";
  //       return;
  //     }
  //     if (this.isNear(x, left, margin) && this.isNear(y, bottom, margin)) {
  //       this.canvas.style.cursor = "nesw-resize";
  //       this.resizeTarget = rect;
  //       this.resizeEdge = "bottom-left";
  //       return;
  //     }
  //     if (this.isNear(x, right, margin) && this.isNear(y, bottom, margin)) {
  //       this.canvas.style.cursor = "nwse-resize";
  //       this.resizeTarget = rect;
  //       this.resizeEdge = "bottom-right";
  //       return;
  //     }
  //     if (this.isNear(x, left, margin) && y >= top && y <= bottom) {
  //       this.canvas.style.cursor = "ew-resize";
  //       this.resizeTarget = rect;
  //       this.resizeEdge = "left";
  //       return;
  //     }
  //     if (this.isNear(x, right, margin) && y >= top && y <= bottom) {
  //       this.canvas.style.cursor = "ew-resize";
  //       this.resizeTarget = rect;
  //       this.resizeEdge = "right";
  //       return;
  //     }
  //     if (this.isNear(y, top, margin) && x >= left && x <= right) {
  //       this.canvas.style.cursor = "ns-resize";
  //       this.resizeTarget = rect;
  //       this.resizeEdge = "top";
  //       return;
  //     }
  //     if (this.isNear(y, bottom, margin) && x >= left && x <= right) {
  //       this.canvas.style.cursor = "ns-resize";
  //       this.resizeTarget = rect;
  //       this.resizeEdge = "bottom";
  //       return;
  //     }
  //   }
  //   // shiv code core
  //   for (let obj of this.selectedObjects) {
  //     if (obj.type !== 'instance') continue;

  //     const inst = obj.ref;
  //     const refCell = layoutEngine.getCellByName(inst.ref);
  //     if (!refCell) continue;

  //     const { offsetX: ox, offsetY: oy } = this.getChildBoundingBoxCenterOffset(refCell);

  //     let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  //     for (let el of refCell.elements) {
  //       if (el.type !== "rectangle") continue;

  //       const elX = inst.x + ox + el.x;
  //       const elY = inst.y + oy + el.y;
  //       const width = el.width;
  //       const height = el.height;

  //       minX = Math.min(minX, elX);
  //       minY = Math.min(minY, elY);
  //       maxX = Math.max(maxX, elX + width);
  //       maxY = Math.max(maxY, elY + height);
  //     }

  //     if (this.isNear(x, minX, margin) && this.isNear(y, minY, margin)) {
  //       this.canvas.style.cursor = "nwse-resize";
  //       this.resizeTarget = inst;
  //       this.resizeEdge = "top-left";
  //       return;
  //     }
  //     if (this.isNear(x, maxX, margin) && this.isNear(y, minY, margin)) {
  //       this.canvas.style.cursor = "nesw-resize";
  //       this.resizeTarget = inst;
  //       this.resizeEdge = "top-right";
  //       return;
  //     }
  //     if (this.isNear(x, minX, margin) && this.isNear(y, maxY, margin)) {
  //       this.canvas.style.cursor = "nesw-resize";
  //       this.resizeTarget = inst;
  //       this.resizeEdge = "bottom-left";
  //       return;
  //     }
  //     if (this.isNear(x, maxX, margin) && this.isNear(y, maxY, margin)) {
  //       this.canvas.style.cursor = "nwse-resize";
  //       this.resizeTarget = inst;
  //       this.resizeEdge = "bottom-right";
  //       return;
  //     }
  //     if (this.isNear(x, minX, margin) && y >= minY && y <= maxY) {
  //       this.canvas.style.cursor = "ew-resize";
  //       this.resizeTarget = inst;
  //       this.resizeEdge = "left";
  //       return;
  //     }
  //     if (this.isNear(x, maxX, margin) && y >= minY && y <= maxY) {
  //       this.canvas.style.cursor = "ew-resize";
  //       this.resizeTarget = inst;
  //       this.resizeEdge = "right";
  //       return;
  //     }
  //     if (this.isNear(y, minY, margin) && x >= minX && x <= maxX) {
  //       this.canvas.style.cursor = "ns-resize";
  //       this.resizeTarget = inst;
  //       this.resizeEdge = "top";
  //       return;
  //     }
  //     if (this.isNear(y, maxY, margin) && x >= minX && x <= maxX) {
  //       this.canvas.style.cursor = "ns-resize";
  //       this.resizeTarget = inst;
  //       this.resizeEdge = "bottom";
  //       return;
  //     }
  //   }
  //   // end shiv
  //   this.canvas.style.cursor = "default";
  // }

  checkResizeCursor(e) {
    const x = (e.offsetX - this.offsetX) / this.scale;
    const y = (e.offsetY - this.offsetY) / this.scale;

    this.resizeTarget = null;
    this.resizeEdge = null;

    const selectedRects = this.selectedObjects
      .filter(obj => obj.type === 'rectangle')
      .map(obj => obj.ref);

    const margin = 5 / this.scale;

    // 🔒 Skip resize if any selected object is locked
    for (let obj of this.selectedObjects) {
      if (obj.ref?.locked) return;
    }

    // ================= RECTANGLES =================
    for (let rect of selectedRects) {
      this.normalizeRectForResize(rect);

      const left = rect.x;
      const right = rect.x + rect.width;
      const top = rect.y;
      const bottom = rect.y + rect.height;

      // ---- corners ----
      if (this.isNear(x, left, margin) && this.isNear(y, top, margin)) {
        this.canvas.style.cursor = "nwse-resize";
        this.resizeTarget = rect;
        this.resizeEdge = "top-left";
        return;
      }
      if (this.isNear(x, right, margin) && this.isNear(y, top, margin)) {
        this.canvas.style.cursor = "nesw-resize";
        this.resizeTarget = rect;
        this.resizeEdge = "top-right";
        return;
      }
      if (this.isNear(x, left, margin) && this.isNear(y, bottom, margin)) {
        this.canvas.style.cursor = "nesw-resize";
        this.resizeTarget = rect;
        this.resizeEdge = "bottom-left";
        return;
      }
      if (this.isNear(x, right, margin) && this.isNear(y, bottom, margin)) {
        this.canvas.style.cursor = "nwse-resize";
        this.resizeTarget = rect;
        this.resizeEdge = "bottom-right";
        return;
      }

      // ---- LEFT / RIGHT (🔥 FIXED: margin on Y range) ----
      if (
        this.isNear(x, left, margin) &&
        y >= top - margin &&
        y <= bottom + margin
      ) {
        this.canvas.style.cursor = "ew-resize";
        this.resizeTarget = rect;
        this.resizeEdge = "left";
        return;
      }

      if (
        this.isNear(x, right, margin) &&
        y >= top - margin &&
        y <= bottom + margin
      ) {
        this.canvas.style.cursor = "ew-resize";
        this.resizeTarget = rect;
        this.resizeEdge = "right";
        return;
      }

      // ---- TOP / BOTTOM ----
      if (
        this.isNear(y, top, margin) &&
        x >= left - margin &&
        x <= right + margin
      ) {
        this.canvas.style.cursor = "ns-resize";
        this.resizeTarget = rect;
        this.resizeEdge = "top";
        return;
      }

      if (
        this.isNear(y, bottom, margin) &&
        x >= left - margin &&
        x <= right + margin
      ) {
        this.canvas.style.cursor = "ns-resize";
        this.resizeTarget = rect;
        this.resizeEdge = "bottom";
        return;
      }
    }

    // ================= INSTANCES (unchanged except margin safety) =================
    for (let obj of this.selectedObjects) {
      if (obj.type !== 'instance') continue;

      const inst = obj.ref;
      const refCell = layoutEngine.getCellByName(inst.ref);
      if (!refCell) continue;

      const { offsetX: ox, offsetY: oy } =
        this.getChildBoundingBoxCenterOffset(refCell);

      let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

      for (let el of refCell.elements) {
        if (el.type !== "rectangle") continue;

        const elX = inst.x + ox + el.x;
        const elY = inst.y + oy + el.y;

        minX = Math.min(minX, elX);
        minY = Math.min(minY, elY);
        maxX = Math.max(maxX, elX + el.width);
        maxY = Math.max(maxY, elY + el.height);
      }

      if (this.isNear(x, minX, margin) && this.isNear(y, minY, margin)) {
        this.canvas.style.cursor = "nwse-resize";
        this.resizeTarget = inst;
        this.resizeEdge = "top-left";
        return;
      }
      if (this.isNear(x, maxX, margin) && this.isNear(y, minY, margin)) {
        this.canvas.style.cursor = "nesw-resize";
        this.resizeTarget = inst;
        this.resizeEdge = "top-right";
        return;
      }
      if (this.isNear(x, minX, margin) && this.isNear(y, maxY, margin)) {
        this.canvas.style.cursor = "nesw-resize";
        this.resizeTarget = inst;
        this.resizeEdge = "bottom-left";
        return;
      }
      if (this.isNear(x, maxX, margin) && this.isNear(y, maxY, margin)) {
        this.canvas.style.cursor = "nwse-resize";
        this.resizeTarget = inst;
        this.resizeEdge = "bottom-right";
        return;
      }

      if (
        this.isNear(x, minX, margin) &&
        y >= minY - margin &&
        y <= maxY + margin
      ) {
        this.canvas.style.cursor = "ew-resize";
        this.resizeTarget = inst;
        this.resizeEdge = "left";
        return;
      }

      if (
        this.isNear(x, maxX, margin) &&
        y >= minY - margin &&
        y <= maxY + margin
      ) {
        this.canvas.style.cursor = "ew-resize";
        this.resizeTarget = inst;
        this.resizeEdge = "right";
        return;
      }

      if (
        this.isNear(y, minY, margin) &&
        x >= minX - margin &&
        x <= maxX + margin
      ) {
        this.canvas.style.cursor = "ns-resize";
        this.resizeTarget = inst;
        this.resizeEdge = "top";
        return;
      }

      if (
        this.isNear(y, maxY, margin) &&
        x >= minX - margin &&
        x <= maxX + margin
      ) {
        this.canvas.style.cursor = "ns-resize";
        this.resizeTarget = inst;
        this.resizeEdge = "bottom";
        return;
      }
    }

    this.canvas.style.cursor = "default";
  }



  // startResize(e) {
  //   this.pendingRecordState = true;

  //   if (!this.resizeTarget || !this.resizeEdge) return false;
  //   // Check if target is locked
  //   const targetObj = this.selectedObjects.find(obj =>
  //     obj.ref === this.resizeTarget
  //   );
  //   if (targetObj?.ref?.locked) {
  //     console.log("🔒 Cannot resize locked element");
  //     return false;
  //   }

  //   this.normalizeRectForResize(this.resizeTarget);

  //   const x = (e.offsetX - this.offsetX) / this.scale;
  //   const y = (e.offsetY - this.offsetY) / this.scale;
  //   this.startResizePos = { x, y };
  //   this.startResizeRect = { ...this.resizeTarget };

  //   this.isResizing = true;
  //   this.startResizeRects = this.selectedObjects
  //     .filter(obj => obj.type === "rectangle")
  //     .map(obj => ({
  //       id: obj.id,
  //       x: obj.ref.x,
  //       y: obj.ref.y,
  //       width: obj.ref.width,
  //       height: obj.ref.height
  //     }));


  //   return true;

  // }
  startResize(e) {
    this.pendingRecordState = true;

    const x = (e.offsetX - this.offsetX) / this.scale;
    const y = (e.offsetY - this.offsetY) / this.scale;
    const margin = 5 / this.scale;

    this.resizeTarget = null;
    this.resizeEdge = null;

    // 🔁 RE-DETECT resize target & edge (CRITICAL FIX)
    for (const obj of this.selectedObjects) {
      if (obj.type !== "rectangle") continue;
      if (obj.ref?.locked) continue;

      const rect = obj.ref;

      // 🔴 normalize uploaded rectangles HERE
      this.normalizeRectForResize(rect);

      const left = rect.x;
      const right = rect.x + rect.width;
      const top = rect.y;
      const bottom = rect.y + rect.height;

      if (this.isNear(x, left, margin) && this.isNear(y, top, margin)) {
        this.resizeTarget = rect;
        this.resizeEdge = "top-left";
        break;
      }
      if (this.isNear(x, right, margin) && this.isNear(y, top, margin)) {
        this.resizeTarget = rect;
        this.resizeEdge = "top-right";
        break;
      }
      if (this.isNear(x, left, margin) && this.isNear(y, bottom, margin)) {
        this.resizeTarget = rect;
        this.resizeEdge = "bottom-left";
        break;
      }
      if (this.isNear(x, right, margin) && this.isNear(y, bottom, margin)) {
        this.resizeTarget = rect;
        this.resizeEdge = "bottom-right";
        break;
      }
      if (this.isNear(x, left, margin) && y >= top && y <= bottom) {
        this.resizeTarget = rect;
        this.resizeEdge = "left";
        break;
      }
      if (this.isNear(x, right, margin) && y >= top && y <= bottom) {
        this.resizeTarget = rect;
        this.resizeEdge = "right";
        break;
      }
      if (this.isNear(y, top, margin) && x >= left && x <= right) {
        this.resizeTarget = rect;
        this.resizeEdge = "top";
        break;
      }
      if (this.isNear(y, bottom, margin) && x >= left && x <= right) {
        this.resizeTarget = rect;
        this.resizeEdge = "bottom";
        break;
      }
    }

    // ❌ Still nothing found → not a resize
    if (!this.resizeTarget || !this.resizeEdge) return false;

    // 🔒 Lock check
    const targetObj = this.selectedObjects.find(o => o.ref === this.resizeTarget);
    if (targetObj?.ref?.locked) return false;

    this.startResizePos = { x, y };

    this.startResizeRect = {
      x: this.resizeTarget.x,
      y: this.resizeTarget.y,
      width: this.resizeTarget.width,
      height: this.resizeTarget.height
    };

    this.isResizing = true;

    // 🔴 Normalize ALL selected rectangles (multi-resize safe)
    this.startResizeRects = this.selectedObjects
      .filter(o => o.type === "rectangle")
      .map(o => {
        this.normalizeRectForResize(o.ref);
        return {
          id: o.id,
          x: o.ref.x,
          y: o.ref.y,
          width: o.ref.width,
          height: o.ref.height
        };
      });

    return true;
  }




  performResize(e) {
    if (!this.isResizing || !this.startResizeRects) return;

    if (this.pendingRecordState) {
      this.recordState();
      this.pendingRecordState = false;
    }

    // Check if any selected rectangle is locked
    const hasLocked = this.selectedObjects.some(obj =>
      obj.type === 'rectangle' && obj.ref.locked
    );
    if (hasLocked) {
      console.log("🔒 Cannot resize locked elements");
      this.isResizing = false;
      return;
    }

    const x = (e.offsetX - this.offsetX) / this.scale;
    const y = (e.offsetY - this.offsetY) / this.scale;
    const deltaX = this.snapToGrid(x - this.startResizePos.x);
    const deltaY = this.snapToGrid(y - this.startResizePos.y);

    // Minimum dimensions to prevent single-line rectangles
    const MIN_DIMENSION = 20; // Or whatever your minimum should be

    for (let info of this.startResizeRects) {
      const obj = this.selectedObjects.find(o => o.id === info.id);
      if (!obj) continue;

      if (obj.type === "rectangle") {
        const rect = obj.ref;
        this.normalizeRectForResize(rect);

        // Reset to original dimensions before applying new resize
        rect.x = info.x;
        rect.y = info.y;
        rect.width = info.width;
        rect.height = info.height;

        // Use the helper function to apply edge-based resizing
        this.applyResize(rect, deltaX, deltaY, this.resizeEdge, info);

        // Normalize dimensions if they become negative
        if (rect.width < 0) {
          rect.x += rect.width;
          rect.width = Math.abs(rect.width);
        }
        if (rect.height < 0) {
          rect.y += rect.height;
          rect.height = Math.abs(rect.height);
        }

        // Prevent creating single-line rectangles
        if (rect.width < MIN_DIMENSION) {
          rect.width = MIN_DIMENSION;
          // Adjust position if needed (for left/top resizing)
          if (this.resizeEdge.includes('left')) {
            rect.x = info.x + info.width - MIN_DIMENSION;
          }
        }
        if (rect.height < MIN_DIMENSION) {
          rect.height = MIN_DIMENSION;
          // Adjust position if needed (for top resizing)
          if (this.resizeEdge.includes('top')) {
            rect.y = info.y + info.height - MIN_DIMENSION;
          }
        }
        // ✅ NEW: update layoutEngine for instance rendering
        const cellName = ProjectManager.getSelectedCell();
        layoutEngine.editElement(cellName, rect.id, {
          x: rect.x,
          y: rect.y,
          width: rect.width,
          height: rect.height
        });
      }
      else if (obj.type === "instance" && obj.ref) {
        // Instance scaling logic remains unchanged
        const inst = obj;
        const refCell = layoutEngine.getCellByName(inst.ref);
        if (!refCell) continue;

        const { offsetX, offsetY } = this.getChildBoundingBoxCenterOffset(refCell);

        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        for (let el of refCell.elements) {
          if (el.type !== "rectangle") continue;
          const elX = offsetX + el.x;
          const elY = offsetY + el.y;
          minX = Math.min(minX, elX);
          minY = Math.min(minY, elY);
          maxX = Math.max(maxX, elX + el.width);
          maxY = Math.max(maxY, elY + el.height);
        }

        const boxWidth = maxX - minX;
        const boxHeight = maxY - minY;

        const rawScaleX = (x - inst.x) / boxWidth;
        const rawScaleY = (y - inst.y) / boxHeight;

        const snappedWidth = this.snapToGrid(rawScaleX * boxWidth);
        const snappedHeight = this.snapToGrid(rawScaleY * boxHeight);

        const scaleX = snappedWidth / boxWidth;
        const scaleY = snappedHeight / boxHeight;

        const newScale = Math.max(0.05, Math.min(scaleX, scaleY));
        inst.scale = newScale;
      }
    }

    this.draw();
  }

  // 🔧 Helper function to apply edge-based rectangle resizing
  applyResize(rect, dx, dy, edge, original) {
    switch (edge) {
      case "left":
        rect.x = original.x + dx;
        rect.width = original.width - dx;
        break;
      case "right":
        rect.width = original.width + dx;
        break;
      case "top":
        rect.y = original.y + dy;
        rect.height = original.height - dy;
        break;
      case "bottom":
        rect.height = original.height + dy;
        break;
      case "top-left":
        rect.x = original.x + dx;
        rect.width = original.width - dx;
        rect.y = original.y + dy;
        rect.height = original.height - dy;
        break;
      case "top-right":
        rect.width = original.width + dx;
        rect.y = original.y + dy;
        rect.height = original.height - dy;
        break;
      case "bottom-left":
        rect.x = original.x + dx;
        rect.width = original.width - dx;
        rect.height = original.height + dy;
        break;
      case "bottom-right":
        rect.width = original.width + dx;
        rect.height = original.height + dy;
        break;
    }
  }

  endResize() {
    if (!this.resizeTarget) return;

    // ✅ Normalize rectangle dimensions after resize ends
    if (this.resizeTarget.width < 0) {
      this.resizeTarget.x += this.resizeTarget.width;
      this.resizeTarget.width = Math.abs(this.resizeTarget.width);
    }

    if (this.resizeTarget.height < 0) {
      this.resizeTarget.y += this.resizeTarget.height;
      this.resizeTarget.height = Math.abs(this.resizeTarget.height);
    }

    this.isResizing = false;
    this.pendingRecordState = false;
    this.resizeTarget = null;
    this.resizeEdge = null;
    this.startResizeRect = null;
  }


  startMarquee(e) {
    const currentTime = Date.now();
    const isDoubleClick = (currentTime - this.lastClickTime < 300);
    this.lastClickTime = currentTime;

    const x = (e.offsetX - this.offsetX) / this.scale;
    const y = (e.offsetY - this.offsetY) / this.scale;

    this.selectionDragStart = { x, y };
    this.selectionBox = null;
    this.isSelecting = false;
    this.leftClickMarquee = (e.button === 0);
    this.doubleClickOnly = isDoubleClick;
  }

  updateMarquee(e) {
    if ((this.leftClickMarquee || this.doubleClickOnly) && ToolManager.getCurrentTool() === 'select' && !this.isDragging) {
      const currX = (e.offsetX - this.offsetX) / this.scale;
      const currY = (e.offsetY - this.offsetY) / this.scale;

      const dx = Math.abs(currX - this.selectionDragStart.x);
      const dy = Math.abs(currY - this.selectionDragStart.y);

      if (!this.isSelecting && (dx > 4 || dy > 4)) {
        this.selectionBox = {
          x: this.selectionDragStart.x,
          y: this.selectionDragStart.y,
          width: 0,
          height: 0
        };
        this.isSelecting = true;
      }

      if (this.isSelecting && this.selectionBox) {
        this.selectionBox.width = currX - this.selectionBox.x;
        this.selectionBox.height = currY - this.selectionBox.y;
        this.draw();
      }
    }
  }

  //   finishMarquee(e) {
  //   if (this.isSelecting && this.selectionBox && ToolManager.getCurrentTool() === 'select') {
  //     const { x, y, width, height } = this.selectionBox;
  //     const x1 = Math.min(x, x + width);
  //     const y1 = Math.min(y, y + height);
  //     const x2 = Math.max(x, x + width);
  //     const y2 = Math.max(y, y + height);

  //     const cellName = ProjectManager.getSelectedCell();

  //     // ================= CREATED DATA =================
  //     const rectLayers = InstanceLibrary.getAllInstances()[cellName] || {};
  //     const allRects = Object.values(rectLayers).flat();
  //     const allLabels = labelLibrary.getAllLabels(cellName);
  //     const allPolygons = polygonLibrary.getAllPolygons(cellName) || [];

  //     const currentCell = layoutEngine.getCellByName(cellName);
  //     const createdInstances = currentCell?.instances || [];

  //     // ================= UPLOADED DATA =================
  //     const uploadedCell = layoutEngine.getUploadedCell(cellName);
  //     const uploadedElements = uploadedCell?.elements || [];
  //     const uploadedInstances = uploadedCell?.instances || [];

  //     // ================= CREATED RECTANGLES =================
  //     const selectedRects = allRects.filter(rect =>
  //       rect.visible !== false &&
  //       rect.x >= x1 && rect.x + rect.width <= x2 &&
  //       rect.y >= y1 && rect.y + rect.height <= y2
  //     );

  //     // ================= UPLOADED RECTANGLES =================
  //     const selectedUploadedRects = uploadedElements.filter(el => {
  //       if (el.type !== 'rectangle') return false;
  //       if (!this.isElementLayerVisible(el)) return false;

  //       const xStart = el.x ?? el.x1 ?? 0;
  //       const yStart = el.y ?? el.y1 ?? 0;
  //       const xEnd = el.x2 ?? (xStart + (el.width ?? 0));
  //       const yEnd = el.y2 ?? (yStart + (el.height ?? 0));

  //       const left = Math.min(xStart, xEnd);
  //       const right = Math.max(xStart, xEnd);
  //       const top = Math.min(yStart, yEnd);
  //       const bottom = Math.max(yStart, yEnd);

  //       return left >= x1 && right <= x2 && top >= y1 && bottom <= y2;
  //     });

  //     // ================= CREATED LABELS =================
  //     const selectedLabels = allLabels.filter(label =>
  //       label.visible !== false &&
  //       label.x >= x1 && label.x <= x2 &&
  //       label.y >= y1 && label.y <= y2
  //     );

  //     // ================= POLYGONS (SINGLE SOURCE ONLY) =================
  //     // const allPolygons = polygonLibrary.getAllPolygons(cellName) || [];

  //     const selectedPolygons = allPolygons.filter(poly =>
  //       poly.visible !== false &&
  //       this.isElementLayerVisible(poly) &&
  //       Array.isArray(poly.points) &&
  //       poly.points.every(([px, py]) =>
  //         px >= x1 && px <= x2 &&
  //         py >= y1 && py <= y2
  //       )
  //     );

  //     // ================= CREATED INSTANCES =================
  //     const selectedInstances = createdInstances.filter(inst => {
  //       const refCell = layoutEngine.getCellByName(inst.ref);
  //       if (!refCell) return false;

  //       const { offsetX: ox, offsetY: oy } =
  //         this.getChildBoundingBoxCenterOffset(refCell);

  //       return (refCell.elements || []).some(el => {
  //         if (el.type !== "rectangle") return false;
  //         if (el.visible === false) return false;

  //         const elX = inst.x + ox + el.x;
  //         const elY = inst.y + oy + el.y;

  //         return (
  //           elX >= x1 && elX + el.width <= x2 &&
  //           elY >= y1 && elY + el.height <= y2
  //         );
  //       });
  //     });

  //     // ================= UPLOADED INSTANCES =================
  //     const selectedUploadedInstances = uploadedInstances.filter(inst => {
  //       if (
  //         inst.layerNumber != null &&
  //         !layerLibrary.isLayerVisible(inst.layerNumber, inst.datatypeNumber)
  //       ) {
  //         return false;
  //       }

  //       const refCell = layoutEngine.getUploadedCell(inst.ref);
  //       if (!refCell) return false;

  //       const { offsetX: ox, offsetY: oy } =
  //         this.getChildBoundingBoxCenterOffset(refCell);

  //       return (refCell.elements || []).some(el => {
  //         if (el.type !== "rectangle") return false;
  //         if (!this.isElementLayerVisible(el)) return false;

  //         const elX = inst.x + ox + el.x;
  //         const elY = inst.y + oy + el.y;

  //         return (
  //           elX >= x1 && elX + el.width <= x2 &&
  //           elY >= y1 && elY + el.height <= y2
  //         );
  //       });
  //     });

  //     // ================= COMBINE =================
  //     const combined = [
  //       // ...selectedRects.map(r => ({ id: r.id, type: 'rectangle', ref: r, isUploaded: false })),
  //       ...selectedUploadedRects.map(el => ({ id: el.id, type: 'rectangle', ref: el, isUploaded: true })),
  //       ...selectedLabels.map(l => ({ id: l.id, type: 'label', ref: l })),
  //       ...selectedInstances.map(inst => ({ id: inst.id, type: 'instance', ref: inst, isUploaded: false })),
  //       ...selectedUploadedInstances.map(inst => ({ id: inst.id, type: 'instance', ref: inst, isUploaded: true })),
  //       ...selectedPolygons.map(p => ({ id: p.id, type: 'polygon', ref: p, isUploaded: false }))
  //       // ...selectedUploadedPolygons.map(p => ({ id: p.id, type: 'polygon', ref: p, isUploaded: true }))
  //     ];

  //     this.selectedRects = selectedRects;
  //     this.selectedObjects = combined;
  //     selectionLibrary.setSelection(combined);
  //     this.draw();
  //   }

  //   this.selectionBox = null;
  //   this.isSelecting = false;
  //   this.selectionDragStart = null;
  //   this.leftClickMarquee = false;
  //   this.doubleClickOnly = false;
  // }


  finishMarquee(e) {
    if (this.isSelecting && this.selectionBox && ToolManager.getCurrentTool() === 'select') {

      const { x, y, width, height } = this.selectionBox;
      const x1 = Math.min(x, x + width);
      const y1 = Math.min(y, y + height);
      const x2 = Math.max(x, x + width);
      const y2 = Math.max(y, y + height);

      const cellName = ProjectManager.getSelectedCell();

      const currentCell = layoutEngine.getCellByName(cellName);
      const uploadedCell = layoutEngine.getUploadedCell(cellName);

      const createdInstances = currentCell?.instances || [];
      const uploadedInstances = uploadedCell?.instances || [];

      const allLabels = labelLibrary.getAllLabels(cellName);

      // ================= MERGE ELEMENTS =================
      const baseElements = uploadedCell?.elements || [];
      const overlayElements = currentCell?.elements || [];

      const mergedMap = new Map();

      [...baseElements, ...overlayElements].forEach(el => {
        mergedMap.set(el.id, el);
      });

      const mergedElements = Array.from(mergedMap.values());

      // ================= STRICT RECTANGLE DEDUPE (GEOMETRY SAFE) =================
      const rectangleMap = new Map();

      mergedElements.forEach(el => {
        if (el.type === 'rectangle') {
          const key = `r-${el.x}-${el.y}-${el.width}-${el.height}-${el.layerId}`;
          if (!rectangleMap.has(key)) {
            rectangleMap.set(key, el);
          }
        }
      });

      const uniqueRectangles = Array.from(rectangleMap.values());

      // ================= POLYGONS (DEDUPED BY ID) =================
      const polygonMap = new Map();

      mergedElements.forEach(el => {
        if (el.type === 'polygon') {
          polygonMap.set(el.id, el);
        }
      });

      const uniquePolygons = Array.from(polygonMap.values());

      // ================= RECTANGLE SELECTION =================
      const selectedRects = uniqueRectangles.filter(el => {

        if (el.visible === false) return false;
        if (!this.isElementLayerVisible(el)) return false;

        const xStart = el.x ?? el.x1 ?? 0;
        const yStart = el.y ?? el.y1 ?? 0;
        const xEnd = el.x2 ?? (xStart + (el.width ?? 0));
        const yEnd = el.y2 ?? (yStart + (el.height ?? 0));

        const left = Math.min(xStart, xEnd);
        const right = Math.max(xStart, xEnd);
        const top = Math.min(yStart, yEnd);
        const bottom = Math.max(yStart, yEnd);

        return left >= x1 && right <= x2 && top >= y1 && bottom <= y2;
      });

      // ================= POLYGON SELECTION =================
      const selectedPolygons = uniquePolygons.filter(poly =>
        poly.visible !== false &&
        this.isElementLayerVisible(poly) &&
        Array.isArray(poly.points) &&
        poly.points.every(([px, py]) =>
          px >= x1 && px <= x2 &&
          py >= y1 && py <= y2
        )
      );

      // ================= LABEL SELECTION =================
      const selectedLabels = allLabels.filter(label =>
        label.visible !== false &&
        label.x >= x1 && label.x <= x2 &&
        label.y >= y1 && label.y <= y2
      );

      // ================= CREATED INSTANCES =================
      // const selectedInstances = createdInstances.filter(inst => {
      //   const refCell = layoutEngine.getCellByName(inst.ref);
      //   if (!refCell) return false;

      //   const { offsetX: ox, offsetY: oy } =
      //     this.getChildBoundingBoxCenterOffset(refCell);

      //   return (refCell.elements || []).some(el => {
      //     if (el.type !== "rectangle") return false;
      //     if (el.visible === false) return false;

      //     const elX = inst.x + ox + el.x;
      //     const elY = inst.y + oy + el.y;

      //     return (
      //       elX >= x1 && elX + el.width <= x2 &&
      //       elY >= y1 && elY + el.height <= y2
      //     );
      //   });
      // });
      const selectedInstances = createdInstances.filter(inst => {
        const refCell = layoutEngine.getCellByName(inst.ref);
        if (!refCell) return false;

        const { offsetX: ox, offsetY: oy } =
          this.getChildBoundingBoxCenterOffset(refCell);

        return (refCell.elements || []).some(el => {

          if (el.visible === false) return false;

          // ===== RECTANGLE =====
          if (el.type === "rectangle") {

            const elX = inst.x + ox + el.x;
            const elY = inst.y + oy + el.y;

            return (
              elX >= x1 && elX + el.width <= x2 &&
              elY >= y1 && elY + el.height <= y2
            );
          }

          // ===== POLYGON =====
          if (el.type === "polygon" && Array.isArray(el.points)) {

            return el.points.every(([px, py]) => {
              const globalX = inst.x + ox + px;
              const globalY = inst.y + oy + py;

              return (
                globalX >= x1 && globalX <= x2 &&
                globalY >= y1 && globalY <= y2
              );
            });
          }

          return false;
        });
      });


      // ================= UPLOADED INSTANCES =================
      // const selectedUploadedInstances = uploadedInstances.filter(inst => {
      //   if (
      //     inst.layerNumber != null &&
      //     !layerLibrary.isLayerVisible(inst.layerNumber, inst.datatypeNumber)
      //   ) {
      //     return false;
      //   }

      //   const refCell = layoutEngine.getUploadedCell(inst.ref);
      //   if (!refCell) return false;

      //   const { offsetX: ox, offsetY: oy } =
      //     this.getChildBoundingBoxCenterOffset(refCell);

      //   return (refCell.elements || []).some(el => {
      //     if (el.type !== "rectangle") return false;
      //     if (!this.isElementLayerVisible(el)) return false;

      //     const elX = inst.x + ox + el.x;
      //     const elY = inst.y + oy + el.y;

      //     return (
      //       elX >= x1 && elX + el.width <= x2 &&
      //       elY >= y1 && elY + el.height <= y2
      //     );
      //   });
      // });
      const selectedUploadedInstances = uploadedInstances.filter(inst => {

        if (
          inst.layerNumber != null &&
          !layerLibrary.isLayerVisible(inst.layerNumber, inst.datatypeNumber)
        ) {
          return false;
        }

        const refCell = layoutEngine.getUploadedCell(inst.ref);
        if (!refCell) return false;

        const { offsetX: ox, offsetY: oy } =
          this.getChildBoundingBoxCenterOffset(refCell);

        return (refCell.elements || []).some(el => {

          if (el.visible === false) return false;

          // ===== RECTANGLE =====
          if (el.type === "rectangle") {

            const elX = inst.x + ox + el.x;
            const elY = inst.y + oy + el.y;

            return (
              elX >= x1 && elX + el.width <= x2 &&
              elY >= y1 && elY + el.height <= y2
            );
          }

          // ===== POLYGON =====
          if (el.type === "polygon" && Array.isArray(el.points)) {

            return el.points.every(([px, py]) => {
              const globalX = inst.x + ox + px;
              const globalY = inst.y + oy + py;

              return (
                globalX >= x1 && globalX <= x2 &&
                globalY >= y1 && globalY <= y2
              );
            });
          }

          return false;
        });
      });


      // ================= COMBINE =================
      const combined = [
        ...selectedRects.map(r => ({ id: r.id, type: 'rectangle', ref: r })),
        ...selectedPolygons.map(p => ({ id: p.id, type: 'polygon', ref: p })),
        ...selectedLabels.map(l => ({ id: l.id, type: 'label', ref: l })),
        ...selectedInstances.map(inst => ({ id: inst.id, type: 'instance', ref: inst, isUploaded: false })),
        ...selectedUploadedInstances.map(inst => ({ id: inst.id, type: 'instance', ref: inst, isUploaded: true }))
      ];

      this.selectedRects = selectedRects;
      this.selectedObjects = combined;

      selectionLibrary.setSelection(combined);
      this.draw();
    }

    this.selectionBox = null;
    this.isSelecting = false;
    this.selectionDragStart = null;
    this.leftClickMarquee = false;
    this.doubleClickOnly = false;
  }










  drawSelectionMarquee() {
    if (!(this.selectionBox && this.isSelecting)) return;

    const { x, y, width, height } = this.selectionBox;
    const ctx = this.ctx;

    ctx.save();
    ctx.translate(this.offsetX, this.offsetY);
    ctx.scale(this.scale, this.scale);
    ctx.strokeStyle = "#0077ff";
    // ctx.setLineDash([6]);
    ctx.lineWidth = 1 / this.scale;
    ctx.setLineDash([6 * ctx.lineWidth]);
    ctx.strokeRect(x, y, width, height);
    ctx.setLineDash([]);
    ctx.restore();
  }



  updateSelectedProperty(propertyName, value) {
    if (!this.selectedObjects.length) return;

    for (let obj of this.selectedObjects) {
      if (propertyName === 'layerId') {
        // ✅ Move object to another layer
        if (obj.type === 'rectangle') {
          // Remove from old layer
          InstanceLibrary.deleteRectangle(obj.ref.layerId, obj.ref.id);
          // Update layerId
          obj.ref.layerId = value;
          // Re-add to new layer
          InstanceLibrary.addRectangle(obj.ref.layerId, obj.ref.x, obj.ref.y, obj.ref.width, obj.ref.height, obj.ref);
        } else if (obj.type === 'label') {
          // Remove from old layer
          labelLibrary.deleteLabel(obj.ref.layerId, obj.ref.id);
          // Update layerId
          obj.ref.layerId = value;
          // Re-add to new layer
          labelLibrary.addLabel(obj.ref.layerId, obj.ref.x, obj.ref.y, obj.ref.text, obj.ref.color);
        }
      } else if (obj.ref.hasOwnProperty(propertyName)) {
        obj.ref[propertyName] = value;
      }
    }

    this.draw();
    console.log(`✅ Updated ${propertyName} to ${value}`);
  }

  updateSelectedPropertyById(id, type, key, value) {
    const target = this.selectedObjects.find(obj => obj.id === id && obj.type === type);
    if (!target || !target.ref) return;

    // special: layer handled elsewhere
    if (key === 'layerId') {
      this.updateSelectedLayer(value);
      return;
    }

    // update the runtime selection object (so outline updates immediately)
    target.ref[key] = value;

    // ===== Persist change to layoutEngine for authoritative state =====
    const cellName = ProjectManager.getSelectedCell();

    if (type === 'rectangle') {
      // rectangles already saved elsewhere in your code, but safe to keep
      layoutEngine.editElement(cellName, id, {
        x: target.ref.x,
        y: target.ref.y,
        width: target.ref.width,
        height: target.ref.height
      });
    }
    else if (type === 'label') {
      // if you use labelLibrary or layoutEngine for labels, update there
      // example: layoutEngine.editElement(cellName, id, { x: target.ref.x, y: target.ref.y, text: target.ref.text });
      // or use your labelLibrary api if preferred
      // labelLibrary.editLabel(cellName, id, { x: target.ref.x, y: target.ref.y, text: target.ref.text });
    }
    else if (type === 'instance') {
      // mark: target.ref is the instance object
      // persist into created cell instances
      layoutEngine.editInstance(cellName, id, {
        x: target.ref.x,
        y: target.ref.y,
        rotation: target.ref.rotation,
        scale: target.ref.scale,
        mirror_x: target.ref.mirror_x,
        mirror_y: target.ref.mirror_y
      });

      // also update uploaded cell instances (if instance was uploaded)
      const uploadedCell = layoutEngine.getUploadedCell(cellName);
      if (uploadedCell?.instances) {
        const match = uploadedCell.instances.find(i => i.id === id);
        if (match) {
          Object.assign(match, {
            x: target.ref.x,
            y: target.ref.y,
            rotation: target.ref.rotation,
            scale: target.ref.scale,
            mirror_x: target.ref.mirror_x,
            mirror_y: target.ref.mirror_y
          });
        }
      }
    }

    // redraw
    this.draw();
    console.log(`✅ Updated ${key} for ${type} ID ${id} to`, value);
  }


  // In CanvasEngine.js - update or add this method
  updateSelectedLayer(newLayerId) {
    this.recordState();
    if (!this.selectedObjects?.length) return;

    const cellName = ProjectManager.getSelectedCell();
    const success = layerLibrary.updateObjectsLayer(this.selectedObjects, newLayerId, cellName);

    if (success) {
      this.draw();
      console.log(`🔄 Updated selected objects to layer ${newLayerId}`);
    }
  }


  getSelectedProperties() {
    if (!this.selectedObjects || !this.selectedObjects.length) return [];

    return this.selectedObjects.map(obj => ({
      id: obj.id,
      type: obj.type,
      properties: { ...obj.ref } // deep copy of properties
    }));
  }









  focusOnLabel(labelId) {
    const label = labelLibrary.getLabelById(labelId);
    if (label) {
      const labelX = label.x;
      const labelY = label.y;

      // 1️⃣ zoom in karo (maan lo default zoom 1 hai):
      this.scale = 2; // ya jo bhi zoom factor chahiye

      // 2️⃣ center ko adjust karo
      this.offsetX = -labelX * this.scale + this.canvas.width / 2;
      this.offsetY = -labelY * this.scale + this.canvas.height / 2;

      this.draw(); // redraw canvas
    }
  }



  //=======================================================================================================================================================

  // instance section

  getChildBoundingBox(cell, offsetX = 0, offsetY = 0) {
    let minX = Infinity, minY = Infinity;
    let maxX = -Infinity, maxY = -Infinity;

    // 🔹 1. Process all elements (rectangles, labels, polygons)
    for (let el of cell.elements || []) {
      if (el.type === "rectangle") {
        const x1 = el.x ?? el.x1 ?? 0;
        const y1 = el.y ?? el.y1 ?? 0;
        const x2 = el.x2 ?? (x1 + (el.width ?? 0));
        const y2 = el.y2 ?? (y1 + (el.height ?? 0));

        const absX1 = offsetX + Math.min(x1, x2);
        const absY1 = offsetY + Math.min(y1, y2);
        const absX2 = offsetX + Math.max(x1, x2);
        const absY2 = offsetY + Math.max(y1, y2);

        minX = Math.min(minX, absX1);
        minY = Math.min(minY, absY1);
        maxX = Math.max(maxX, absX2);
        maxY = Math.max(maxY, absY2);
      }
      else if (el.type === "label") {
        const x = el.coordinates?.[0]?.[0] ?? el.x ?? 0;
        const y = el.coordinates?.[0]?.[1] ?? el.y ?? 0;
        const width = el.width ?? 40; // Default width for labels
        const height = el.height ?? 20; // Default height for labels

        const absX = offsetX + x;
        const absY = offsetY + y;

        minX = Math.min(minX, absX);
        minY = Math.min(minY, absY);
        maxX = Math.max(maxX, absX + width);
        maxY = Math.max(maxY, absY + height);
      }
      else if (el.type === "polygon" && Array.isArray(el.points)) {
        for (let point of el.points) {
          const [px, py] = Array.isArray(point) ? point : [point.x, point.y];
          const absX = offsetX + px;
          const absY = offsetY + py;

          minX = Math.min(minX, absX);
          minY = Math.min(minY, absY);
          maxX = Math.max(maxX, absX);
          maxY = Math.max(maxY, absY);
        }
      }
      else if (el.type === "path" && Array.isArray(el.points)) {
        for (let point of el.points) {
          const [px, py] = Array.isArray(point) ? point : [point.x, point.y];
          const absX = offsetX + px;
          const absY = offsetY + py;

          minX = Math.min(minX, absX);
          minY = Math.min(minY, absY);
          maxX = Math.max(maxX, absX);
          maxY = Math.max(maxY, absY);
        }
      }
    }

    // 🔹 2. Process instances recursively
    for (const inst of cell.instances || []) {
      const childCell = layoutEngine.getUploadedCell(inst.ref);
      if (!childCell) continue;

      // Apply instance transformations
      const instX = offsetX + inst.x;
      const instY = offsetY + inst.y;
      const instScale = inst.scale || 1;
      const instRotation = inst.rotation || 0;

      // Get child bounds without offset (we'll apply transformations)
      const childBounds = this.getChildBoundingBox(childCell, 0, 0);

      if (childBounds.width === 0 || childBounds.height === 0) continue;

      // Apply rotation and scale to get transformed bounds
      const centerX = childBounds.x + childBounds.width / 2;
      const centerY = childBounds.y + childBounds.height / 2;

      const corners = [
        [childBounds.x, childBounds.y],
        [childBounds.x + childBounds.width, childBounds.y],
        [childBounds.x, childBounds.y + childBounds.height],
        [childBounds.x + childBounds.width, childBounds.y + childBounds.height]
      ];

      // Transform each corner
      for (let [cx, cy] of corners) {
        // Translate to center, scale, rotate, then translate back
        let dx = (cx - centerX) * instScale;
        let dy = (cy - centerY) * instScale;

        if (instRotation !== 0) {
          const rad = instRotation * Math.PI / 180;
          const cos = Math.cos(rad);
          const sin = Math.sin(rad);
          const newDx = dx * cos - dy * sin;
          const newDy = dx * sin + dy * cos;
          dx = newDx;
          dy = newDy;
        }

        const finalX = instX + centerX + dx;
        const finalY = instY + centerY + dy;

        minX = Math.min(minX, finalX);
        minY = Math.min(minY, finalY);
        maxX = Math.max(maxX, finalX);
        maxY = Math.max(maxY, finalY);
      }
    }

    if (!isFinite(minX) || !isFinite(minY) || !isFinite(maxX) || !isFinite(maxY)) {
      return { x: 0, y: 0, width: 0, height: 0 };
    }

    return {
      x: minX,
      y: minY,
      maxX,
      maxY,
      width: maxX - minX,
      height: maxY - minY
    };
  }


  getChildBoundingBoxCenterOffset(cell) {
    const bounds = this.getChildBoundingBox(cell);
    const centerX = bounds.x + bounds.width / 2;
    const centerY = bounds.y + bounds.height / 2;

    return {
      offsetX: 0,
      offsetY: 0
    };
  }

  drawHiddenCellOverlay(ctx, cell) {
    const bbox = this.getChildBoundingBox(cell);
    if (!bbox) return;

    ctx.save();
    ctx.strokeStyle = "#00ffff";
    ctx.setLineDash([6, 4]);
    ctx.lineWidth = 1 / this.scale; // keeps line visible under zoom
    ctx.strokeRect(bbox.x, bbox.y, bbox.width, bbox.height);

    ctx.fillStyle = "#00ffff";
    ctx.font = `${Math.max(8, 8 / this.scale)}px monospace`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(
      cell.name,
      bbox.x + bbox.width / 2,
      bbox.y + bbox.height / 2
    );
    ctx.restore();
  }



  getGlobalBoundingBox(
    cell,
    transform = { x: 0, y: 0, scale: 1, rotation: 0, mirror_x: false },
    visited = new Set()
  ) {
    if (!cell || visited.has(cell.name)) return null;
    visited.add(cell.name);

    let minX = Infinity, minY = Infinity;
    let maxX = -Infinity, maxY = -Infinity;

    const angleRad = (transform.rotation || 0) * Math.PI / 180;
    const cos = Math.cos(angleRad), sin = Math.sin(angleRad);

    // Helper: apply global transform (translate, rotate, scale, mirror)
    const applyTransform = (x, y) => {
      if (transform.mirror_x) x = -x;

      // Scale
      let px = x * transform.scale;
      let py = y * transform.scale;

      // Rotate
      const rx = px * cos - py * sin;
      const ry = px * sin + py * cos;

      // Translate
      return {
        x: rx + transform.x,
        y: ry + transform.y,
      };
    };

    const updateBounds = (x, y) => {
      if (Number.isFinite(x) && Number.isFinite(y)) {
        minX = Math.min(minX, x);
        minY = Math.min(minY, y);
        maxX = Math.max(maxX, x);
        maxY = Math.max(maxY, y);
      }
    };

    // 🔹 1. Process all elements (rectangle, polygon, path, label)
    for (const el of cell.elements || []) {
      if (el.type === "rectangle") {
        const x1 = el.x ?? el.x1 ?? 0;
        const y1 = el.y ?? el.y1 ?? 0;
        const x2 = el.x2 ?? (x1 + (el.width ?? 0));
        const y2 = el.y2 ?? (y1 + (el.height ?? 0));

        const corners = [
          { x: x1, y: y1 },
          { x: x2, y: y1 },
          { x: x1, y: y2 },
          { x: x2, y: y2 },
        ];

        for (const c of corners) {
          const { x, y } = applyTransform(c.x, c.y);
          updateBounds(x, y);
        }
      }

      else if (el.type === "polygon" && Array.isArray(el.points)) {
        for (let point of el.points) {
          const [px, py] = Array.isArray(point) ? point : [point.x, point.y];
          const { x, y } = applyTransform(px, py);
          updateBounds(x, y);
        }
      }

      else if (el.type === "path" && Array.isArray(el.points)) {
        for (let point of el.points) {
          const [px, py] = Array.isArray(point) ? point : [point.x, point.y];
          const { x, y } = applyTransform(px, py);
          updateBounds(x, y);
        }
      }

      else if (el.type === "label") {
        const x = el.coordinates?.[0]?.[0] ?? el.x ?? 0;
        const y = el.coordinates?.[0]?.[1] ?? el.y ?? 0;
        const width = el.width ?? 40;
        const height = el.height ?? 20;

        const labelCorners = [
          { x, y },
          { x: x + width, y },
          { x, y: y + height },
          { x: x + width, y: y + height },
        ];

        for (const c of labelCorners) {
          const { x: tx, y: ty } = applyTransform(c.x, c.y);
          updateBounds(tx, ty);
        }
      }
    }

    // 🔹 2. Process instances recursively
    for (const inst of cell.instances || []) {
      const childCell =
        layoutEngine.getUploadedCell(inst.ref) || layoutEngine.getCellByName(inst.ref);
      if (!childCell) continue;

      const childTransform = {
        x: transform.x + inst.x * transform.scale,
        y: transform.y + inst.y * transform.scale,
        scale: transform.scale * (inst.scale || 1),
        rotation: transform.rotation + (inst.rotation || 0),
        mirror_x: transform.mirror_x ^ !!inst.mirror_x, // combine mirroring
      };

      const childBox = this.getGlobalBoundingBox(childCell, childTransform, visited);
      if (childBox) {
        updateBounds(childBox.minX, childBox.minY);
        updateBounds(childBox.maxX, childBox.maxY);
      }
    }

    // 🔹 3. Return final bounding box
    if (!isFinite(minX) || !isFinite(minY) || !isFinite(maxX) || !isFinite(maxY)) {
      return null; // No drawable elements found
    }

    return {
      minX,
      minY,
      maxX,
      maxY,
      width: maxX - minX,
      height: maxY - minY,
    };
  }


  drawTransformedLabel(ctx, label, instX, instY, scale, rotation) {
    const cx = label.x + instX;
    const cy = label.y + instY;
    const lid =
      label.layerId ||
      `${label.layerNumber ?? label.layer}:${label.datatypeNumber ?? label.datatype ?? 0}`;
    const layer = window.layerLibrary?.getLayerById?.(lid);


    ctx.save();
    ctx.translate(this.offsetX, this.offsetY);
    ctx.scale(this.scale, this.scale);
    ctx.translate(cx, cy);
    ctx.rotate((rotation || 0) * Math.PI / 180);
    ctx.font = `${label.fontSize || 12}px sans-serif`;
    ctx.fillStyle = label.color || layer?.color || "#fff"; // ✅ layer color fallback
    ctx.fillText(label.text, 0, 0);
    ctx.restore();
  }

  drawPolygon(ctx, element, scale = 1) {
    if (!ctx || !element?.points || element.points.length < 3) return;
    if (element.visible === false) return;

    ctx.beginPath();

    // Handle point structure: [[x,y], [x,y]] or [{x, y}, ...]
    const [sx, sy] = Array.isArray(element.points[0])
      ? element.points[0]
      : [element.points[0].x, element.points[0].y];
    ctx.moveTo(sx, sy);

    for (let i = 1; i < element.points.length; i++) {
      const [x, y] = Array.isArray(element.points[i])
        ? element.points[i]
        : [element.points[i].x, element.points[i].y];
      ctx.lineTo(x, y);
    }

    ctx.closePath();

    // Layer color fallback
    const layerId = `${element.layerNumber ?? element.layer}:${element.datatypeNumber ?? element.datatype ?? 0}`;
    const layer = layerLibrary.getLayerById?.(layerId);
    const fillColor = element.fill || layer?.color || "rgba(0,255,255,0.3)";
    const strokeColor = element.stroke || layer?.color || "cyan";
    const opacity = element.opacity ?? layer?.pattern?.opacity ?? 1;

    ctx.save();
    ctx.globalAlpha = opacity;
    ctx.fillStyle = fillColor;
    ctx.strokeStyle = strokeColor;
    ctx.lineWidth = 1 / scale;
    ctx.fill();
    ctx.stroke();
    ctx.restore();
  }

  getElementDrawKey(el) {
    if (el.type === "rectangle") {
      return `R:${el.x},${el.y},${el.width},${el.height},${el.layerId}`;
    }

    if (el.type === "polygon") {
      return `P:${el.points.map(p => `${p[0]},${p[1]}`).join('|')}:${el.layerId}`;
    }

    if (el.type === "label") {
      return `L:${el.x},${el.y}:${el.text}:${el.layerId}`;
    }

    return `${el.type}:${el.id}`;
  }



  drawRecursiveInstances(
    cell,
    ctx,
    parentTransform = { x: 0, y: 0, scale: 1, rotation: 0, mirror_x: false, mirror_y: false },
    path = [],
    level = 0
  ) {
    if (!cell || path.includes(cell.name)) return;

    const newPath = [...path, cell.name];

    // ✅ TOP-CELL VISIBILITY CHECK
    const topVisible = visibilityManager.isVisible(cell.name);
    if (!topVisible && level === 0) {
      const bbox = this.getGlobalBoundingBox(cell, parentTransform);
      if (bbox) {
        ctx.save();
        ctx.setLineDash([6, 4]);
        ctx.lineWidth = 2 / Math.max(0.0001, this.scale);
        ctx.strokeStyle = "rgba(0,255,255,0.9)";
        ctx.strokeRect(
          bbox.minX,
          bbox.minY,
          bbox.maxX - bbox.minX,
          bbox.maxY - bbox.minY
        );

        const cx = (bbox.minX + bbox.maxX) / 2;
        const cy = (bbox.minY + bbox.maxY) / 2;
        ctx.font = `${12 / this.scale}px monospace`;
        ctx.fillStyle = "rgba(0,255,255,0.8)";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(cell.name, cx, cy);
        ctx.restore();
      }
      return; // 🚫 Skip drawing everything else if top cell is hidden
    }

    // 🔁 Continue as normal for child instances
    const instances = cell.instances || [];
    for (const inst of instances) {
      const selectedOnly = getSelectedOnlyVisibilityState();
      if (
        level === 0 &&
        selectedOnly.enabled &&
        inst.ref !== selectedOnly.selectedPCellName
      ) {
        continue;
      }

      const instCell = layoutEngine.getCellByName(inst.ref)
      if (!instCell) continue;

      const childLevel = level + 1;

      // 🔄 Compute global transform for this instance
      const baseRotation = parentTransform.rotation + (inst.rotation || 0);

      // Calculate position
      const angleRad = (parentTransform.rotation || 0) * Math.PI / 180;
      const cos = Math.cos(angleRad);
      const sin = Math.sin(angleRad);

      let rotatedX = inst.x * cos - inst.y * sin;
      let rotatedY = inst.x * sin + inst.y * cos;

      const globalTransform = {
        x: parentTransform.x + rotatedX * (parentTransform.scale || 1),
        y: parentTransform.y + rotatedY * (parentTransform.scale || 1),
        scale: parentTransform.scale * (inst.scale || 1),
        rotation: baseRotation,
        mirror_x: inst.mirror_x || false,
        mirror_y: inst.mirror_y || false
      };

      const drawFull =
        childLevel >= this.levelStart && childLevel < this.levelEnd;
      const drawBBoxOnly = childLevel === this.levelEnd;
      let recurse = true;

      // ✅ INSTANCE VISIBILITY CHECK
      const visible = visibilityManager.isVisible(inst.ref);

      if (!visible) {
        // 🟦 Draw bounding box + label at placed position
        const bbox = this.getGlobalBoundingBox(instCell, globalTransform);
        if (bbox) {
          ctx.save();
          ctx.setLineDash([6, 4]);
          ctx.lineWidth = 2 / Math.max(0.0001, this.scale);
          ctx.strokeStyle = "rgba(0,255,255,0.9)";
          ctx.strokeRect(
            bbox.minX,
            bbox.minY,
            bbox.maxX - bbox.minX,
            bbox.maxY - bbox.minY
          );

          const cx = (bbox.minX + bbox.maxX) / 2;
          const cy = (bbox.minY + bbox.maxY) / 2;
          ctx.font = `${12 / this.scale}px monospace`;
          ctx.fillStyle = "rgba(0,255,255,0.8)";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(inst.ref, cx, cy);
          ctx.restore();
        }

        // 🧭 Still recurse into children (so deeper ones can show)
        this.drawRecursiveInstances(instCell, ctx, globalTransform, newPath, childLevel);
        continue;
      }

      // 🟩 VISIBLE instance → full normal draw
      const elementsWithColors =
        instCell.elements?.map((el) => {
          if (el.type === "rectangle") {
            const layerId = `${el.layerNumber ?? el.layer}:${el.datatypeNumber ?? el.datatype ?? 0
              }`;
            const layer = layerLibrary.getLayerById(layerId);
            return {
              ...el,
              fill: layer?.color,
              stroke: el.stroke === "transparent" ? "transparent" : (layer?.color || "red"),
              opacity: el.opacity ?? layer?.pattern?.opacity ?? 0.4,
            };
          }
          return el;
        }) || [];

      const isVisibleByLayer = (el) => {
        let L, D;
        if (el.type === "label") {
          const [Ls, Ds = "0"] = String(el.layerId || "").split(":");
          L = Ls;
          D = Number(Ds) || 0;
        } else {
          L = el.layerNumber ?? el.layer;
          D = el.datatypeNumber ?? el.datatype ?? 0;
        }
        if (L === undefined || L === null || L === "") return true;
        return layerLibrary.isLayerVisible(L, D);
      };

      const toDraw = elementsWithColors.filter(isVisibleByLayer);

      if (drawFull) {
        // 🧱 Draw full detail - FIXED MIRROR TRANSFORM ORDER
        ctx.save();
        ctx.globalAlpha = 1.0;
        ctx.translate(globalTransform.x, globalTransform.y);

        // Apply mirror transformations FIRST - this mirrors around the local origin
        if (globalTransform.mirror_x) {
          ctx.scale(1, -1);
        }
        if (globalTransform.mirror_y) {
          ctx.scale(-1, 1);
        }

        // Then apply rotation
        ctx.rotate((globalTransform.rotation * Math.PI) / 180);

        // Apply scale last
        ctx.scale(globalTransform.scale, globalTransform.scale);
        const activeCell = ProjectManager.getSelectedCell();

        for (let el of toDraw) {
          if (cell.name === activeCell && el.localOverlay) {
            continue;
          }
          if (el.type === "rectangle") {
            InstanceLibrary.drawSingle(ctx, el, globalTransform.scale);
          } else if (el.type === "label") {
            labelLibrary.drawSingle(ctx, el);
          } else if (el.type === "polygon") {
            // this.drawPolygon(el);
            this.drawPolygon(ctx, el, globalTransform.scale);

          }
        }

        ctx.restore();
      } else if (drawBBoxOnly) {
        // 🔲 Bounding box only
        const bbox = this.getGlobalBoundingBox(instCell, globalTransform);
        if (bbox) {
          ctx.save();
          ctx.setLineDash([6, 4]);
          ctx.lineWidth = 2 / Math.max(0.0001, this.scale);
          ctx.strokeStyle = "rgba(255,165,0,0.9)";
          ctx.strokeRect(
            bbox.minX,
            bbox.minY,
            bbox.maxX - bbox.minX,
            bbox.maxY - bbox.minY
          );

          const cx = (bbox.minX + bbox.maxX) / 2;
          const cy = (bbox.minY + bbox.maxY) / 2;
          ctx.font = `${12 / this.scale}px monospace`;
          ctx.fillStyle = "rgba(255,255,255,0.8)";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(instCell.name, cx, cy);
          ctx.restore();
        }
        recurse = false;
      } else if (childLevel > this.levelEnd) {
        recurse = false;
      }

      // 🔁 Recurse if allowed
      if (recurse) {
        this.drawRecursiveInstances(instCell, ctx, globalTransform, newPath, childLevel);
      }
    }
  }



  drawRecursiveUploaded(
    ctx,
    cellName,
    parentTransform = { x: 0, y: 0, rotation: 0, scale: 1 },
    path = [],
    level = 0
  ) {
    const cell = layoutEngine.getUploadedCell(cellName);
    if (!cell || path.includes(cell.name)) return;

    const newPath = [...path, cell.name];
    const drawFull = level >= this.levelStart && level < this.levelEnd;
    const drawBBoxOnly = level === this.levelEnd;
    let recurse = true;

    // ✅ 1️⃣ Check visibility for this cell
    const cellVisible = visibilityManager.isVisible(cell.name);

    // 🟦 If this cell itself is invisible → draw bounding box only
    if (!cellVisible) {
      const bbox = this.getGlobalBoundingBox(cell, parentTransform);
      if (bbox) {
        ctx.save();
        ctx.setLineDash([6, 4]);
        ctx.lineWidth = 2 / Math.max(0.0001, this.scale);
        ctx.strokeStyle = "rgba(0,255,255,0.9)";
        ctx.strokeRect(
          bbox.minX,
          bbox.minY,
          bbox.maxX - bbox.minX,
          bbox.maxY - bbox.minY
        );

        const cx = (bbox.minX + bbox.maxX) / 2;
        const cy = (bbox.minY + bbox.maxY) / 2;
        ctx.font = `${12 / this.scale}px monospace`;
        ctx.fillStyle = "rgba(0,255,255,0.8)";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(cell.name, cx, cy);
        ctx.restore();
        return; // Stop full rendering for this hidden cell
      }

      // Still recurse into children (so child cells can show normally)
      for (const inst of cell.instances || []) {
        const instCell = layoutEngine.getUploadedCell(inst.ref);
        if (!instCell) continue;

        const angleRad = (parentTransform.rotation || 0) * Math.PI / 180;
        const cos = Math.cos(angleRad),
          sin = Math.sin(angleRad);

        const rotatedX = inst.x * cos - inst.y * sin;
        const rotatedY = inst.x * sin + inst.y * cos;

        const newTransform = {
          x: parentTransform.x + rotatedX * (parentTransform.scale || 1),
          y: parentTransform.y + rotatedY * (parentTransform.scale || 1),
          rotation: (parentTransform.rotation || 0) + (inst.rotation || 0),
          scale: (parentTransform.scale || 1) * (inst.scale || 1),
        };
        ctx.globalAlpha = 1.0;
        this.drawRecursiveUploaded(ctx, inst.ref, newTransform, newPath, level + 1);
      }

      return; // Stop full rendering for this hidden cell
    }

    // ✅ 2️⃣ Normal visible cell drawing
    if (drawFull) {
      const isVisibleByLayer = (el) => {
        if (el?.visible === false) return false;
        let L, D;
        if (el.type === "label" || el.type === "Label") {
          const [Ls, Ds = "0"] = String(el.layerId || "").split(":");
          L = Ls;
          D = Number(Ds) || 0;
        } else {
          L = el.layerNumber ?? el.layer;
          D = el.datatypeNumber ?? el.datatype ?? 0;
        }
        if (L === undefined || L === null || L === "") return true;
        return layerLibrary.isLayerVisible(L, D);
      };

      ctx.save();
      ctx.globalAlpha = 1.0;
      ctx.translate(parentTransform.x, parentTransform.y);
      ctx.rotate((parentTransform.rotation || 0) * Math.PI / 180);
      ctx.scale(parentTransform.scale || 1, parentTransform.scale || 1);

      for (const element of (cell.elements || []).filter(isVisibleByLayer)) {
        const activeCell = ProjectManager.getSelectedCell();
        if (cell.name === activeCell && element.localOverlay) {
          continue;
        }
        if (element.type === "rectangle") {
          InstanceLibrary.drawUploadedRectangle(ctx, element);
        } else if (element.type === "polygon") {
          this.drawPolygon(ctx, element);
          // } else if (element.type === "label" || element.type === "Label") {
          //   labelLibrary.drawLabel(ctx, element);
          // }
        } else if (element.type === "label" || element.type === "Label") {
          // Avoid double-render: let LabelLibrary draw labels only for the selected top cells
          const selectedCell = ProjectManager.getSelectedCell();
          if (cell.name !== selectedCell) {
            labelLibrary.drawLabel(ctx, element); // draw for child/nested cells
          }
          // else: skip here, they'll be drawn via labelLibrary.drawAllLabels() for the selected cell
        }
      }

      ctx.restore();
    } else if (drawBBoxOnly) {
      // 🔲 Draw bounding box only for levelEnd
      const bbox = this.getGlobalBoundingBox(cell, parentTransform);
      if (bbox) {
        ctx.save();
        ctx.setLineDash([6, 4]);
        ctx.lineWidth = 2 / Math.max(0.0001, this.scale);
        ctx.strokeStyle = "rgba(255,165,0,0.9)";
        ctx.strokeRect(
          bbox.minX,
          bbox.minY,
          bbox.maxX - bbox.minX,
          bbox.maxY - bbox.minY
        );

        const cx = (bbox.minX + bbox.maxX) / 2;
        const cy = (bbox.minY + bbox.maxY) / 2;
        ctx.font = `${12 / this.scale}px monospace`;
        ctx.fillStyle = "rgba(255,255,255,0.8)";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(cell.name, cx, cy);
        ctx.restore();
      }
      recurse = false;
    } else if (level > this.levelEnd) {
      recurse = false;
    }

    // ✅ 3️⃣ Recurse into children
    if (recurse) {
      for (const inst of cell.instances || []) {
        const instCell = layoutEngine.getUploadedCell(inst.ref);
        if (!instCell) continue;

        // Compute transform for instance placement
        const angleRad = (parentTransform.rotation || 0) * Math.PI / 180;
        const cos = Math.cos(angleRad),
          sin = Math.sin(angleRad);
        const rotatedX = inst.x * cos - inst.y * sin;
        const rotatedY = inst.x * sin + inst.y * cos;

        const newTransform = {
          x: parentTransform.x + rotatedX * (parentTransform.scale || 1),
          y: parentTransform.y + rotatedY * (parentTransform.scale || 1),
          rotation: (parentTransform.rotation || 0) + (inst.rotation || 0),
          scale: (parentTransform.scale || 1) * (inst.scale || 1),
        };

        // 🔍 Visibility check per instance
        const visible = visibilityManager.isVisible(inst.ref);
        if (!visible) {
          const bbox = this.getGlobalBoundingBox(instCell, newTransform);
          if (bbox) {
            ctx.save();
            ctx.setLineDash([6, 4]);
            ctx.lineWidth = 2 / Math.max(0.0001, this.scale);
            ctx.strokeStyle = "rgba(0,255,255,0.9)";
            ctx.strokeRect(
              bbox.minX,
              bbox.minY,
              bbox.maxX - bbox.minX,
              bbox.maxY - bbox.minY
            );

            const cx = (bbox.minX + bbox.maxX) / 2;
            const cy = (bbox.minY + bbox.maxY) / 2;
            ctx.font = `${12 / this.scale}px monospace`;
            ctx.fillStyle = "rgba(0,255,255,0.8)";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(inst.ref, cx, cy);
            ctx.restore();
          }
          continue; // Skip contents for hidden child
        }

        // ✅ Apply mirror + rotation + scale + draw
        ctx.save();

        // Apply parent transform
        ctx.translate(parentTransform.x, parentTransform.y);
        ctx.rotate((parentTransform.rotation || 0) * Math.PI / 180);
        ctx.scale(parentTransform.scale || 1, parentTransform.scale || 1);

        // Move to instance location
        ctx.translate(inst.x, inst.y);

        // Apply mirror using the same boolean flags as drawRecursiveInstances
        if (inst.mirror_x) ctx.scale(1, -1);
        if (inst.mirror_y) ctx.scale(-1, 1);


        // Apply instance-local rotation & scale
        if (inst.rotation) ctx.rotate((inst.rotation || 0) * Math.PI / 180);
        if (inst.scale && inst.scale !== 1) ctx.scale(inst.scale, inst.scale);

        // 🔁 Draw child recursively with identity transform
        ctx.globalAlpha = 1.0;
        this.drawRecursiveUploaded(ctx, inst.ref, { x: 0, y: 0, rotation: 0, scale: 1 }, newPath, level + 1);

        ctx.restore();
      }
    }
  }


  // parametric function start here
  drawFilteredInstances() {
    const { showOnlySelected } = usePlacementStore.getState();
    const selectedDesign = window.getCurrentSelectedPattern?.(); // <-- we'll define this global in next step

    const ctx = this.ctx;
    const activeCell = require('./ProjectManager').default.getSelectedCell();
    const layoutEngine = require('../libraries/layoutEngine').default;

    if (!activeCell) return;

    const cell = layoutEngine.getCellByName(activeCell);
    if (!cell) return;

    ctx.save();
    ctx.clearRect(0, 0, this.canvas.width / this.dpr, this.canvas.height / this.dpr);
    ctx.restore();

    this.drawGrid();

    // 🔁 Only show selected pattern instance
    const instances = cell.instances || [];
    const filteredInstances = showOnlySelected
      ? instances.filter(inst => inst.ref === selectedDesign)
      : instances;

    const labelLibrary = require('../libraries/LabelLibrary').default;
    const labelData = labelLibrary.getAllLabels(activeCell) || [];

    // ✅ Draw filtered instances
    for (let inst of filteredInstances) {
      this.drawInstance(inst); // assumes `drawInstance` is already defined
    }

    // ✅ Also draw labels (unchanged)
    for (let label of labelData) {
      if (labelLibrary.isVisible(label)) {
        ctx.save();
        ctx.translate(this.offsetX, this.offsetY);
        ctx.scale(this.scale, this.scale);
        ctx.fillStyle = 'yellow';
        ctx.font = '12px monospace';
        ctx.fillText(label.text, label.x, label.y);
        ctx.restore();
      }
    }
  }

  // draw3x3DotsOnSelected(patternName) {
  //   const selected =
  //     patternName ||
  //     placementStore.getState().selectedPatterns?.[0]; // ✅ placementStore se le
  //   if (!selected) return alert("❌ No pattern selected");
  //   this.drawDotGridOverPattern(selected, 3);
  // }

  // draw4x4DotsOnSelected(patternName) {
  //   const selected =
  //     patternName ||
  //     placementStore.getState().selectedPatterns?.[0];
  //   if (!selected) return alert("❌ No pattern selected");
  //   this.drawDotGridOverPattern(selected, 4);
  // }

  // draw5x5DotsOnSelected(patternName) {
  //   const selected =
  //     patternName ||
  //     placementStore.getState().selectedPatterns?.[0];
  //   if (!selected) return alert("❌ No pattern selected");
  //   this.drawDotGridOverPattern(selected, 5);
  // }


  // drawDotGridOverPattern(patternName, gridSize) {
  //   const normalize = (str) => str.trim().toLowerCase().replace(/[\s_]+/g, "");

  //   console.log("📌 Requested pattern:", patternName, "Grid Size:", gridSize);

  //   const topCell = layoutEngine.getTopCell();
  //   if (!topCell) {
  //     console.log("❌ No top cell found");
  //     return alert("❌ No top cell found");
  //   }

  //   console.log("📦 Top Cell:", topCell.name || "unnamed", topCell);

  //   const instance = topCell.instances?.find(
  //     (inst) => normalize(inst.ref) === normalize(patternName)
  //   );

  //   if (!instance) {
  //     console.log(`❌ No matching instance found for "${patternName}"`);
  //     return alert(`❌ No instance found for pattern "${patternName}"`);
  //   }

  //   console.log("🔍 Matched instance:", instance);

  //   const bbox = layoutEngine.getBoundingBox(instance.ref);  // ✅ use actual ref
  //   if (!bbox) {
  //     console.log(`❌ No bounding box for "${instance.ref}"`);
  //     return alert(`❌ Bounding box not found for "${instance.ref}"`);
  //   }

  //   console.log("📏 Bounding Box:", bbox);
  //   console.log("📍 Instance Position (x, y):", instance.x, instance.y);

  //   this.dotGridMap[instance.ref] = {
  //     gridSize,
  //     bbox,
  //     offsetX: instance.x,
  //     offsetY: instance.y,
  //   };

  //   console.log("✅ Dot grid stored for:", instance.ref, {
  //     gridSize,
  //     bbox,
  //     offsetX: instance.x,
  //     offsetY: instance.y,
  //   });

  //   this.draw();
  // }




  drawPCellInstanceTree(instance) {
    const ctx = this.ctx;
    const refCell = layoutEngine.getCellByName(instance.ref);
    if (!refCell) return;

    // Draw rectangles in the refCell
    for (const el of refCell.elements || []) {
      if (el.type === "rectangle") {
        const x = (instance.x + el.x + this.offsetX) * this.scale;
        const y = (instance.y + el.y + this.offsetY) * this.scale;
        const w = el.width * this.scale;
        const h = el.height * this.scale;

        ctx.fillStyle = el.fill || "rgba(0,255,0,0.4)";
        ctx.strokeStyle = el.stroke || "green";
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.rect(x, y, w, h);
        ctx.fill();
        if (el.stroke !== "transparent") {
          ctx.strokeStyle = el.stroke || "green";
          ctx.lineWidth = 1;
          ctx.stroke();
        }
      }
    }

    // Draw sub-instances if they exist
    for (const subInst of refCell.instances || []) {
      const newInstance = {
        x: instance.x + subInst.x,
        y: instance.y + subInst.y,
        ref: subInst.ref
      };
      this.drawPCellInstanceTree(newInstance);
    }
  }




  draw3x3DotsOnSelected() {
    const nextDots = [];
    // ✅ Clear old dots before regenerating
    this.pointerDots = [];
    if (!this.selectedObjects || this.selectedObjects.length === 0) {
      console.warn("⚠️ No selected objects for 3x3 dot drawing.");
      return;
    }

    // ✅ IMPORTANT: DO NOT recompute bbox from layoutEngine.getBoundingBox()
    // (that gives local bbox and breaks instance placement)

    this.pointerDots = [];

    const pointerNames = ["UL", "UM", "UR", "LEM", "CENTER", "RM", "LL", "LM", "LR"];

    const get3x3DotPoints = (xll, yll, xur, yur) => {
      const xmid = (xll + xur) / 2;
      const ymid = (yll + yur) / 2;
      return [
        [xll, yll], [xmid, yll], [xur, yll],
        [xll, ymid], [xmid, ymid], [xur, ymid],
        [xll, yur], [xmid, yur], [xur, yur],
      ];
    };

    // ✅ world → screen transform
    const s = this.scale;
    const ox = this.offsetX;
    const oy = this.offsetY;

    this.selectedObjects.forEach(obj => {
      const xll = obj.x;
      const yll = obj.y;
      const xur = obj.x + obj.width;
      const yur = obj.y + obj.height;

      const points = get3x3DotPoints(xll, yll, xur, yur);

      points.forEach(([wx, wy], idx) => {
        const sx = wx * s + ox;
        const sy = wy * s + oy;

        nextDots.push({
          x: sx,
          y: sy,
          wx,
          wy,
          pointer: pointerNames[idx],
          pattern: obj.refName || obj.name,
          instanceId: obj.instanceId,
          parentCellName: obj.parentCellName,
        });
      });
    });
    this.pointerDots = nextDots;
    this.draw();
    console.log(window.canvasEngine.selectedObjects);
  }
  // ✅ Dot identity compare
  isSameDot(a, b) {
    if (!a || !b) return false;
    return a.instanceId === b.instanceId && a.pointer === b.pointer;
  }



  refreshParametricDotsAfterMutation(parentCellName = null) {
    const resolvedParent =
      parentCellName ||
      this.selectedObjects?.[0]?.parentCellName ||
      ParametricDotsLibrary.getParentCellName?.();

    if (!resolvedParent) {
      this.draw();
      return;
    }

    ParametricDotsLibrary.refreshTargetsFromParent(resolvedParent);
    ParametricDotsLibrary.redraw(this, { parentCellName: resolvedParent });
    ParametricDotsLibrary.applyToEngine(this);
    this.draw();
  }

  // ✅ Find clicked dot by screen pixel distance
  findDotAtScreen(sx, sy) {
    if (!Array.isArray(this.pointerDots)) return null;

    const r = this.dotHitRadiusPx || 10;
    const r2 = r * r;

    // nearest dot preference
    let best = null;
    let bestD2 = Infinity;

    for (const d of this.pointerDots) {
      const dx = (d.x ?? 0) - sx;
      const dy = (d.y ?? 0) - sy;
      const d2 = dx * dx + dy * dy;
      if (d2 <= r2 && d2 < bestD2) {
        best = d;
        bestD2 = d2;
      }
    }
    return best;
  }

  // ✅ Handle dot selection (max 2 selected)
  handleDotClick(e) {
    const sx = e.offsetX;
    const sy = e.offsetY;

    const dot = this.findDotAtScreen(sx, sy);
    if (!dot) return false; // not consumed

    // toggle off if clicking same selected dot
    if (this.isSameDot(dot, this.selectedDotA)) {
      this.selectedDotA = null;
    } else if (this.isSameDot(dot, this.selectedDotB)) {
      this.selectedDotB = null;
    } else {
      // pick A then B
      if (!this.selectedDotA) this.selectedDotA = dot;
      else if (!this.selectedDotB) this.selectedDotB = dot;
      else {
        // if already 2 selected -> shift (A = new, B = null)
        this.selectedDotA = dot;
        this.selectedDotB = null;
      }
    }

    this.draw(); // refresh highlight
    return true; // consumed
  }
  // ✅ After moving instances, refresh selectedObjects from latest parentCell.instances
  refreshParametricSelectedObjects(parentCellName) {
    const parentCell =
      window.layoutEngine?.getMergedCell?.(parentCellName) ||
      window.layoutEngine?.getCellByName?.(parentCellName) ||
      window.layoutEngine?.getUploadedCell?.(parentCellName);

    if (!parentCell || !Array.isArray(this.selectedObjects)) return;

    for (const obj of this.selectedObjects) {
      // find the live instance by id
      const inst = (parentCell.instances || []).find((i) => i.id === obj.instanceId);
      if (!inst) continue;

      // bbox of referenced cell (same as BlocksTab)
      const refBBox = window.layoutEngine?.getBoundingBox?.(obj.refName);
      if (!refBBox) continue;

      // ✅ recompute global bbox for dot grid
      obj.x = (inst.x || 0) + (refBBox.x || 0);
      obj.y = (inst.y || 0) + (refBBox.y || 0);
      obj.width = refBBox.width;
      obj.height = refBBox.height;
      obj.parentCellName = parentCellName;
    }
  }
  connectSelectedDots() {
    if (!this.selectedDotA || !this.selectedDotB) {
      alert("⚠️ Please select 2 dots first.");
      return;
    }

    const A = this.selectedDotA;
    const B = this.selectedDotB;

    // same dot / same instance check
    if (this.isSameDot(A, B)) {
      alert("⚠️ Same dot selected twice.");
      return;
    }
    if (A.instanceId === B.instanceId) {
      alert("⚠️ Dono dots same instance ke hain. Alag instances select karo.");
      return;
    }

    // both must belong to same parent cell context
    const parentCellName = A.parentCellName || ProjectManager.getSelectedCell?.();
    if (!parentCellName) {
      alert("⚠️ Parent cell not found.");
      return;
    }

    const parentCell =
      window.layoutEngine?.getMergedCell?.(parentCellName) ||
      window.layoutEngine?.getCellByName?.(parentCellName) ||
      window.layoutEngine?.getUploadedCell?.(parentCellName);

    if (!parentCell) {
      alert("⚠️ Parent cell object not found.");
      return;
    }

    // locate instance A inside parent cell
    const instA = (parentCell.instances || []).find(
      (i) => i.id === A.instanceId && i.ref === A.pattern
    );

    if (!instA) {
      console.warn("instA not found", { A, parentCellName, parentCell });
      alert("⚠️ First selected instance not found in parent cell.");
      return;
    }

    // ✅ compute world delta so that dot A lands on dot B
    const dx = (B.wx ?? 0) - (A.wx ?? 0);
    const dy = (B.wy ?? 0) - (A.wy ?? 0);

    // ✅ move the actual instance in layout data
    instA.x = (instA.x || 0) + dx;
    instA.y = (instA.y || 0) + dy;

    // ✅ also update the cached selectedObjects bbox used for dot drawing
    //   if (Array.isArray(this.selectedObjects)) {
    //   for (const obj of this.selectedObjects) {
    //     if (obj.instanceId === A.instanceId) {
    //       obj.x += dx;
    //       obj.y += dy;
    //       break;
    //     }
    //   }
    // }
    this.refreshParametricSelectedObjects(parentCellName);
    // ✅ clear selection
    this.selectedDotA = null;
    this.selectedDotB = null;
    // ✅ Remove stale dots immediately
    this.pointerDots = [];
    // ✅ recompute dots (because instance moved)
    this.draw3x3DotsOnSelected(); // (agar 4x4/5x5 use karna hai to we’ll store gridSize)
    this.draw(); // safety
  }



  // end parametric functions



  draw() {
    const ctx = this.ctx;

    // 🌐 Clear or Grid
    if (this.showGrid) {
      this.drawGrid();
    } else {
      ctx.save();
      ctx.clearRect(0, 0, this.canvas.width / this.dpr, this.canvas.height / this.dpr);
      ctx.restore();
    }

    const activeLayerId = layerLibrary.getSelectedLayerId();
    const selectedCell = ProjectManager.getSelectedCell();
    const topVisible = visibilityManager.isVisible(selectedCell);
    const selectedOnly = getSelectedOnlyVisibilityState();

    // 🧱 Draw root cell elements (level 0)
    if (!selectedOnly.enabled && topVisible && (0 >= this.levelStart && 0 < this.levelEnd && !(this.levelStart === 0 && this.levelEnd === 0))) {
      // full draw
      InstanceLibrary.drawAll(ctx, this.offsetX, this.offsetY, this.scale, selectedCell, this.previewRect);
      labelLibrary.drawAllLabels(ctx, this.offsetX, this.offsetY, this.scale, activeLayerId, selectedCell, this.previewLabel);
      // if (!this.useUploadedCells) {
      //   InstanceLibrary.drawAll(ctx, this.offsetX, this.offsetY, this.scale, selectedCell, this.previewRect);
      //   labelLibrary.drawAllLabels(ctx, this.offsetX, this.offsetY, this.scale, activeLayerId, selectedCell, this.previewLabel);
      // }
      // 🔺 Polygons in root
      const currentCell = layoutEngine.getCellByName(selectedCell);
      if (currentCell?.elements?.length) {
        ctx.save();
        ctx.translate(this.offsetX, this.offsetY);
        ctx.scale(this.scale, this.scale);

        for (let el of currentCell.elements) {
          if (el.type === "polygon") {
            const L = el.layerNumber ?? el.layer ?? (String(el.layerId || '').split(':')[0]);
            const D = el.datatypeNumber ?? el.datatype ?? Number(String(el.layerId || '').split(':')[1] ?? 0);
            if (layerLibrary.isLayerVisible(L, D)) {
              this.drawPolygon(ctx, el, this.scale);
            }
          }
        }

        ctx.restore();
      }

    } else if (!selectedOnly.enabled && ((0 === this.levelEnd) || (this.levelStart === 0 && this.levelEnd === 0))) {
      // bbox only
      const cell = layoutEngine.getCellByName(selectedCell);
      if (cell) {
        const bbox = this.getGlobalBoundingBox(cell);
        if (bbox) {
          ctx.save();
          ctx.translate(this.offsetX, this.offsetY);
          ctx.scale(this.scale, this.scale);
          ctx.setLineDash([6, 4]);
          ctx.lineWidth = 2 / Math.max(0.0001, this.scale);
          ctx.strokeStyle = "rgba(255,165,0,0.9)";
          ctx.fillStyle = "rgba(255,165,0,0.1)";
          // 🏷️ Cell name at the center
          const centerX = (bbox.minX + bbox.maxX) / 2;
          const centerY = (bbox.minY + bbox.maxY) / 2;
          ctx.font = `${12 / this.scale}px monospace`;
          ctx.fillStyle = "rgba(255,255,255,0.8)";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(cell.name, centerX, centerY);
          ctx.strokeRect(
            bbox.minX,
            bbox.minY,
            bbox.maxX - bbox.minX,
            bbox.maxY - bbox.minY
          );
          ctx.restore();
        }
      }
    }


    //parametric code
    // if (this.pointerDots?.length) {
    //   const ctx = this.ctx;
    //   ctx.save();

    //   // ✅ world transform so dots follow instances + pan + zoom
    //   ctx.translate(this.offsetX, this.offsetY);
    //   ctx.scale(this.scale, this.scale);

    //   for (const d of this.pointerDots) {
    //     // ✅ highlight (optional)
    //     let fill = "cyan";
    //     if (this.isSameDot?.(d, this.selectedDotA)) fill = "orange";
    //     else if (this.isSameDot?.(d, this.selectedDotB)) fill = "lime";

    //     ctx.fillStyle = fill;

    //     // radius in world so it stays same on screen
    //     const r = 3 / Math.max(0.0001, this.scale);

    //     ctx.beginPath();
    //     ctx.arc(d.wx, d.wy, r, 0, 2 * Math.PI);
    //     ctx.fill();

    //     ctx.font = `${10 / Math.max(0.0001, this.scale)}px monospace`;
    //     ctx.fillText(d.pointer, d.wx + (5 / this.scale), d.wy + (10 / this.scale));
    //   }

    //   ctx.restore();
    // }



    // ... inside draw() method ...

    // 🟢 Parametric PCell Rendering Section
    const topCell = layoutEngine.getTopCell();
    if (topCell && topCell.instances) {
      for (const inst of topCell.instances) {
        if (selectedOnly.enabled && inst.ref !== selectedOnly.selectedPCellName) {
          continue;
        }

        if (hasPlacedPCell(inst.ref)) {
          this.drawPCellInstanceTree(inst);
        }
      }
    }

    // ... rest of the draw() code ...

    // end parametric code


    // 🔁 Draw recursive instances (created cells)
    const currentCell = layoutEngine.getCellByName(selectedCell);
    if (currentCell) {
      ctx.save();
      ctx.globalAlpha = 1.0;
      ctx.translate(this.offsetX, this.offsetY);
      ctx.scale(this.scale, this.scale);
      this.drawRecursiveInstances(currentCell, ctx);
      ctx.restore();
    }

    // 👁️‍🗨️ Preview Instance (deep nested support)
    if (!selectedOnly.enabled && this.currentTool === "instance" && this.previewInstance) {
      const { ref, x, y } = this.previewInstance;
      // const rootCell = layoutEngine.getCellByName(ref);
      const rootCell = layoutEngine.getCell(ref);
      if (!rootCell) return;

      const globalScale = this.scale;
      ctx.save();
      ctx.translate(this.offsetX, this.offsetY);
      ctx.scale(globalScale, globalScale);

      const drawCellRecursive = (cell, originX, originY, scale = 1, rotation = 0, visited = new Set()) => {
        if (!cell || visited.has(cell.name)) return;
        const newVisited = new Set(visited);
        newVisited.add(cell.name);

        const rad = rotation * Math.PI / 180;
        const { offsetX, offsetY } = this.getChildBoundingBoxCenterOffset(cell);
        const drawn = new Set();

        ctx.save();
        ctx.globalAlpha = 1;
        ctx.translate(originX, originY);
        ctx.rotate(rad);
        ctx.scale(scale, scale);
        ctx.translate(offsetX, offsetY);

        // 🧱 Draw elements
        for (let el of cell.elements || []) {
          const key = this.getElementDrawKey(el);

          if (drawn.has(key)) continue;
          drawn.add(key);
          if (el.type === "rectangle") {
            InstanceLibrary.drawSingle(ctx, el, 1);
          } else if (el.type === "label") {
            labelLibrary.drawSingle(ctx, el, 1);
          } else if (el.type === "polygon") {
            const L = el.layerNumber ?? el.layer ?? (String(el.layerId || '').split(':')[0]);
            const D = el.datatypeNumber ?? el.datatype ?? Number(String(el.layerId || '').split(':')[1] ?? 0);
            if (layerLibrary.isLayerVisible(L, D)) {
              this.drawPolygon(ctx, el, scale);
            }
          }
        }

        // 🔁 Draw nested instances
        for (let inst of cell.instances || []) {
          // const childCell = layoutEngine.getCellByName(inst.ref);
          const childCell = layoutEngine.getCell(inst.ref);
          if (!childCell) continue;

          drawCellRecursive(
            childCell,
            inst.x,
            inst.y,
            inst.scale || 1,
            inst.rotation || 0,
            visited
          );
        }

        ctx.restore();
      };

      drawCellRecursive(rootCell, x, y, 1, 0);
      ctx.restore();
    }

    // 👁️‍🗨️ Preview Label
    if (this.previewLabel) {
      ctx.save();
      ctx.translate(this.offsetX, this.offsetY);
      ctx.scale(this.scale, this.scale);
      labelLibrary.drawSingle(ctx, this.previewLabel);
      ctx.restore();
    }

    // 🔁 Uploaded vs Created
    if (this.useUploadedCells && !selectedOnly.enabled) {
      const uploadedCells = layoutEngine.getUploadedCells();
      ctx.save();
      ctx.globalAlpha = 1.0;
      ctx.translate(this.offsetX, this.offsetY);
      ctx.scale(this.scale, this.scale);

      const cell = uploadedCells.find(c => c.name === selectedCell);
      if (cell) {
        this.drawRecursiveUploaded(ctx, cell.name, { x: 0, y: 0, scale: 1, rotation: 0 }, [], 0);
      }

      ctx.restore();
    } else {
      const currentCell = layoutEngine.getCellByName(ProjectManager.getSelectedCell());
      if (currentCell) {
        ctx.save();
        ctx.translate(this.offsetX, this.offsetY);
        ctx.scale(this.scale, this.scale);
        ctx.globalAlpha = 1.0;
        this.drawRecursiveInstances(currentCell, ctx);
        ctx.restore();
      }
    }



    // 🔲 Selection Outline
    const selectedObjectsToDraw = selectedOnly.enabled
      ? (this.selectedObjects || []).filter(
        (obj) =>
          obj.type === "instance" &&
          obj.ref?.ref === selectedOnly.selectedPCellName
      )
      : this.selectedObjects;

    if (selectedObjectsToDraw?.length) {
      ctx.save();
      ctx.translate(this.offsetX, this.offsetY);
      ctx.scale(this.scale, this.scale);
      ctx.strokeStyle = "#ffffff";
      ctx.lineWidth = 2 / this.scale;
      ctx.setLineDash([6, 4]);
      ctx.lineDashOffset = -this.dashOffset;

      for (let obj of selectedObjectsToDraw) {
        if (obj.type === "rectangle") {
          const rect = obj.ref;
          const angle = (rect.rotation || 0) * Math.PI / 180;
          const cx = rect.x + rect.width / 2;
          const cy = rect.y + rect.height / 2;

          ctx.save();
          ctx.translate(cx, cy);
          ctx.rotate(angle);
          ctx.translate(-cx, -cy);
          ctx.strokeRect(rect.x, rect.y, rect.width, rect.height);
          ctx.restore();
        }
        else if (obj.type === "label") {
          const label = obj.ref;
          ctx.font = `${label.fontSize}px ${label.fontType || 'monospace'}`;
          const width = ctx.measureText(label.text).width;
          const height = label.fontSize;

          let boxX = label.x;
          let boxY = label.y;

          switch (label.justification) {
            case 'upperleft': break;
            case 'upperright': boxX -= width; break;
            case 'lowerleft': boxY -= height; break;
            case 'lowerright': boxX -= width; boxY -= height; break;
            case 'center': boxX -= width / 2; boxY -= height / 2; break;
            case 'centerleft': boxY -= height / 2; break;
            case 'centerright': boxX -= width; boxY -= height / 2; break;
          }

          ctx.strokeRect(boxX - 4, boxY - 2, width + 8, height + 8);
        }
        else if (obj.type === "instance") {
          const inst = obj.ref;
          const refCell = obj.isUploaded
            ? layoutEngine.getUploadedCell(inst.ref)
            : layoutEngine.getCellByName(inst.ref);

          if (!refCell) continue;

          const bbox = this.getChildBoundingBox(refCell);
          const { offsetX: childOffsetX, offsetY: childOffsetY } = this.getChildBoundingBoxCenterOffset(refCell);

          const theta = (inst.rotation || 0) * Math.PI / 180;
          const s = inst.scale || 1;

          ctx.save();
          // Move to instance position
          ctx.translate(inst.x, inst.y);

          // --- APPLY MIRROR first (use same convention as drawRecursiveUploaded)
          // support inst.mirror ("X"|"Y"|"XY") or boolean inst.mirror_x (true => "X")
          let mirrorType = "NONE";
          if (inst.mirror_x && inst.mirror_y) mirrorType = "XY";
          else if (inst.mirror_x) mirrorType = "X";
          else if (inst.mirror_y) mirrorType = "Y";

          if (mirrorType === "X") {
            // In your draw code mirror_x was implemented as ctx.scale(1, -1)
            ctx.scale(1, -1);
          } else if (mirrorType === "Y") {
            ctx.scale(-1, 1);
          } else if (mirrorType === "XY") {
            ctx.scale(-1, -1);
          }
          // Apply rotation if any
          if (theta !== 0) ctx.rotate(theta);
          // Apply scale if any
          if (s !== 1) ctx.scale(s, s);

          // Keep stroke thickness screen-consistent
          ctx.lineWidth = 2 / (this.scale * s);

          // Draw bounding box relative to child offset
          ctx.strokeRect(
            childOffsetX + bbox.x,
            childOffsetY + bbox.y,
            bbox.width,
            bbox.height
          );

          ctx.restore();
        }


        if (obj.type === "polygon") {
          const pts = obj.ref.points;
          if (!pts || pts.length < 3) continue;

          ctx.beginPath();
          ctx.moveTo(pts[0][0], pts[0][1]);
          for (let i = 1; i < pts.length; i++) {
            ctx.lineTo(pts[i][0], pts[i][1]);
          }
          ctx.closePath();

          ctx.setLineDash([4, 2]);
          ctx.strokeStyle = "#ffffff";
          ctx.lineWidth = 2 / this.scale;
          ctx.stroke();
          ctx.setLineDash([]);
        }
      }

      ctx.setLineDash([]);
      ctx.restore();
    }

    // ✏️ Rectangle Tool Cursor
    if (this.currentTool === "rectangle") {
      this.rectangleHandler.drawCursorRect(ctx, this.offsetX, this.offsetY, this.scale, this.lastPointer);
    }

    // 📏 Ruler
    if (this.currentTool === "ruler") {
      this.rulerHandler.drawRulers();
    }

    // Communication window 📧
    if (this.currentTool === "bug&imp") {
      // console.log("Drawing feature requests and bug reports");
      this.FeatureRenderer.drawData();
    }

    if (ToolManager.getCurrentTool() === "polygon" && this.polygonHandler) {
      this.ctx.save();
      this.ctx.translate(this.offsetX, this.offsetY);
      this.ctx.scale(this.scale, this.scale);
      this.polygonHandler.drawPreview(this.ctx);
      this.ctx.restore();
    }

    // 🟡 Label blinking cursor
    if (this.currentTool === "label" && this.lastPointer) {
      this.labelHandler.drawBlinkingCursor(this.ctx, this.offsetX, this.offsetY, this.scale, this.lastPointer);
    }

    this.drc.renderViolations();

    // ➕ Red axis lines
    ctx.save();
    ctx.translate(this.offsetX, this.offsetY);
    ctx.scale(this.scale, this.scale);
    ctx.beginPath();
    ctx.moveTo(-1000000000000, 0);
    ctx.lineTo(1000000000000, 0);
    ctx.moveTo(0, -1000000000000);
    ctx.lineTo(0, 1000000000000);
    ctx.lineWidth = 1 / this.scale;
    ctx.strokeStyle = "#ff0000";
    ctx.stroke();
    ctx.restore();

    // 🟦 Marquee + Ruler
    this.rulerHandler.drawRulers();
    this.drawSelectionMarquee();

    ParametricDotsLibrary.syncFromEngine(this);
    ParametricDotsLibrary.draw(this, {
      selectedRefName: selectedOnly.enabled
        ? selectedOnly.selectedPCellName
        : "",
    });
  }





  loadFromJSON(data) {
    const instances = data.instances || [];
    this.instanceManager.clearAll();
    instances.forEach((inst) => this.instanceManager.addInstance(inst));
    hierarchyManager.setInstances(instances);
    this.draw();
  }



}
